webpackJsonp([114276838955818,60335399758886],{

/***/ 254:
/***/ (function(module, exports) {

	module.exports = {"data":{"posts":{"edges":[{"node":{"excerpt":"In  Between the World and Me  by Ta-Nehisi Coates, he writes: “Black people love their children with a kind of obsession. You are all we…","fields":{"slug":"/between-the-world-and-me/","prefix":"2020-06-29"},"frontmatter":{"title":"Between the World and Me","subTitle":"Through the lense of the Hierarchy of Needs","category":"books","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/coates-3bf4fac197772fb82868175243ed890d-9e3e1.jpg","srcSet":"/static/coates-3bf4fac197772fb82868175243ed890d-9e3e1.jpg 1x,\n/static/coates-3bf4fac197772fb82868175243ed890d-670ee.jpg 1.5x,\n/static/coates-3bf4fac197772fb82868175243ed890d-e72f0.jpg 2x,\n/static/coates-3bf4fac197772fb82868175243ed890d-a0b5c.jpg 3x","srcWebp":"/static/coates-3bf4fac197772fb82868175243ed890d-dc95d.webp","srcSetWebp":"/static/coates-3bf4fac197772fb82868175243ed890d-dc95d.webp 1x,\n/static/coates-3bf4fac197772fb82868175243ed890d-23c19.webp 1.5x,\n/static/coates-3bf4fac197772fb82868175243ed890d-312b2.webp 2x,\n/static/coates-3bf4fac197772fb82868175243ed890d-aa8fc.webp 3x"}}]}}}},{"node":{"excerpt":"The Sirens of Titan  by Kurt Vonnegut aims to explore morality and the purpose of life, effectively giving guidance on both themes. As in…","fields":{"slug":"/sirens-of-titan/","prefix":"2020-06-18"},"frontmatter":{"title":"The Sirens of Titan","subTitle":"On morality and purpose","category":"books","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-9e3e1.jpg","srcSet":"/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-9e3e1.jpg 1x,\n/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-670ee.jpg 1.5x,\n/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-e72f0.jpg 2x,\n/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-a0b5c.jpg 3x","srcWebp":"/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-dc95d.webp","srcSetWebp":"/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-dc95d.webp 1x,\n/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-23c19.webp 1.5x,\n/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-312b2.webp 2x,\n/static/sirens-of-titan-8ffd10d2cae46d7dc7b9a164f39ea35f-aa8fc.webp 3x"}}]}}}},{"node":{"excerpt":"Hello! Thanks for visiting my site, as a token of my appreciation, here’s a quote for you. “The master has failed more times than the…","fields":{"slug":"/first-post/","prefix":"2020-06-13"},"frontmatter":{"title":"Hi","subTitle":"First post, here we go","category":"misc","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-9e3e1.jpeg","srcSet":"/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-9e3e1.jpeg 1x,\n/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-670ee.jpeg 1.5x,\n/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-e72f0.jpeg 2x","srcWebp":"/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-dc95d.webp","srcSetWebp":"/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-dc95d.webp 1x,\n/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-23c19.webp 1.5x,\n/static/hi-11d5f46b53a3f6b52a1106af4b64a04d-312b2.webp 2x"}}]}}}}]},"pages":{"edges":[{"node":{"fields":{"slug":"/about/","prefix":"1"},"frontmatter":{"title":"About","menuTitle":"About"}}}]},"parts":{"edges":[{"node":{"html":"<p><strong>Thomas Nguyen</strong></p>","frontmatter":{"title":"author"}}},{"node":{"html":"<!-- * this is a demo site of the gatsby-starter-personal-blog\n* GatsbyJS, ReactJs, CSS in JS - [Front-end web development](https://dev.greglobinski.com)\n","frontmatter":{"title":"footnote"}}},{"node":{"html":"<p>I’m a Frontend Software Engineer living in the Bay area.</p>","frontmatter":{"title":"info"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(630);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(254);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if there are children and not `src` or `srcSet` */
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenClassNameProp && _react.default.isValidElement(childrenProp)) {
	    var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	    children = _react.default.cloneElement(childrenProp, {
	      className: childrenClassName
	    });
	  } else {
	    children = childrenProp;
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Attributes applied to the `img` element if the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(199));

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _keycode = _interopRequireDefault(__webpack_require__(57));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(113));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _focusVisible = __webpack_require__(205);
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(203));
	
	var _createRippleHandler = _interopRequireDefault(__webpack_require__(204));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 'none',
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    }
	  },
	
	  /* Styles applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Styles applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/* istanbul ignore if */
	
	exports.styles = styles;
	
	if (false) {
	  throw new Error('Material-UI: react@16.3.0 or greater is required.');
	}
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	
	var ButtonBase =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ButtonBase, _React$Component);
	
	  function ButtonBase() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ButtonBase);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.ripple = null;
	    _this.keyDown = false;
	    _this.button = null;
	    _this.focusVisibleTimeout = null;
	    _this.focusVisibleCheckTime = 50;
	    _this.focusVisibleMaxCheckTimes = 5;
	    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
	      clearTimeout(_this.focusVisibleTimeout);
	
	      if (_this.state.focusVisible) {
	        _this.setState({
	          focusVisible: false
	        });
	      }
	    });
	    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
	    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
	      if (_this.state.focusVisible) {
	        event.preventDefault();
	      }
	    });
	    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
	    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
	    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
	    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
	      clearTimeout(_this.focusVisibleTimeout);
	
	      if (_this.state.focusVisible) {
	        _this.setState({
	          focusVisible: false
	        });
	      }
	    });
	    _this.state = {};
	
	    _this.onRippleRef = function (node) {
	      _this.ripple = node;
	    };
	
	    _this.onFocusVisibleHandler = function (event) {
	      _this.keyDown = false;
	
	      _this.setState({
	        focusVisible: true
	      });
	
	      if (_this.props.onFocusVisible) {
	        _this.props.onFocusVisible(event);
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          component = _this$props.component,
	          focusRipple = _this$props.focusRipple,
	          onKeyDown = _this$props.onKeyDown,
	          onClick = _this$props.onClick;
	      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations
	
	      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
	        _this.keyDown = true;
	        event.persist();
	
	        _this.ripple.stop(event, function () {
	          _this.ripple.start(event);
	        });
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      } // Keyboard accessibility for non interactive elements
	
	
	      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
	        event.preventDefault();
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    };
	
	    _this.handleKeyUp = function (event) {
	      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
	        _this.keyDown = false;
	        event.persist();
	
	        _this.ripple.stop(event, function () {
	          _this.ripple.pulsate(event);
	        });
	      }
	
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(event);
	      }
	    };
	
	    _this.handleFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      } // Fix for https://github.com/facebook/react/issues/7769
	
	
	      if (!_this.button) {
	        _this.button = event.currentTarget;
	      }
	
	      event.persist();
	      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
	        _this.onFocusVisibleHandler(event);
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ButtonBase, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.button = _reactDom.default.findDOMNode(this);
	      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));
	
	      if (this.props.action) {
	        this.props.action({
	          focusVisible: function focusVisible() {
	            _this2.setState({
	              focusVisible: true
	            });
	
	            _this2.button.focus();
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
	        this.ripple.pulsate();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.button = null;
	      clearTimeout(this.focusVisibleTimeout);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props2 = this.props,
	          action = _this$props2.action,
	          buttonRef = _this$props2.buttonRef,
	          centerRipple = _this$props2.centerRipple,
	          children = _this$props2.children,
	          classes = _this$props2.classes,
	          classNameProp = _this$props2.className,
	          component = _this$props2.component,
	          disabled = _this$props2.disabled,
	          disableRipple = _this$props2.disableRipple,
	          disableTouchRipple = _this$props2.disableTouchRipple,
	          focusRipple = _this$props2.focusRipple,
	          focusVisibleClassName = _this$props2.focusVisibleClassName,
	          onBlur = _this$props2.onBlur,
	          onFocus = _this$props2.onFocus,
	          onFocusVisible = _this$props2.onFocusVisible,
	          onKeyDown = _this$props2.onKeyDown,
	          onKeyUp = _this$props2.onKeyUp,
	          onMouseDown = _this$props2.onMouseDown,
	          onMouseLeave = _this$props2.onMouseLeave,
	          onMouseUp = _this$props2.onMouseUp,
	          onTouchEnd = _this$props2.onTouchEnd,
	          onTouchMove = _this$props2.onTouchMove,
	          onTouchStart = _this$props2.onTouchStart,
	          tabIndex = _this$props2.tabIndex,
	          TouchRippleProps = _this$props2.TouchRippleProps,
	          type = _this$props2.type,
	          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
	      var buttonProps = {};
	      var ComponentProp = component;
	
	      if (ComponentProp === 'button' && other.href) {
	        ComponentProp = 'a';
	      }
	
	      if (ComponentProp === 'button') {
	        buttonProps.type = type || 'button';
	        buttonProps.disabled = disabled;
	      } else {
	        buttonProps.role = 'button';
	      }
	
	      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyUp: this.handleKeyUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchMove: this.handleTouchMove,
	        onTouchStart: this.handleTouchStart,
	        tabIndex: disabled ? '-1' : tabIndex,
	        className: className,
	        ref: buttonRef
	      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
	        innerRef: this.onRippleRef,
	        center: centerRipple
	      }, TouchRippleProps)) : null);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (typeof prevState.focusVisible === 'undefined') {
	        return {
	          focusVisible: false,
	          lastDisabled: nextProps.disabled
	        };
	      } // The blur won't fire when the disabled state is set on a focused input.
	      // We need to book keep the focused state manually.
	
	
	      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
	        return {
	          focusVisible: false,
	          lastDisabled: nextProps.disabled
	        };
	      }
	
	      return {
	        lastDisabled: nextProps.disabled
	      };
	    }
	  }]);
	  return ButtonBase;
	}(_react.default.Component);
	
	ButtonBase.propTypes =  false ? {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports `focusVisible()` action.
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes.default.func,
	
	  /**
	   * Use that property to pass a ref callback to the native button component.
	   */
	  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This property can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Properties applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This property passes the value to the `type` attribute of the native button component.
	   * Valid property values include `button`, `submit`, and `reset`.
	   */
	  type: _propTypes.default.string
	} : {};
	ButtonBase.defaultProps = {
	  centerRipple: false,
	  component: 'button',
	  disableRipple: false,
	  disableTouchRipple: false,
	  focusRipple: false,
	  tabIndex: '0',
	  type: 'button'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _Transition = _interopRequireDefault(__webpack_require__(106));
	
	/**
	 * @ignore - internal component.
	 */
	var Ripple =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Ripple, _React$Component);
	
	  function Ripple() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Ripple);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      visible: false,
	      leaving: false
	    };
	
	    _this.handleEnter = function () {
	      _this.setState({
	        visible: true
	      });
	    };
	
	    _this.handleExit = function () {
	      _this.setState({
	        leaving: true
	      });
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Ripple, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          pulsate = _this$props.pulsate,
	          rippleX = _this$props.rippleX,
	          rippleY = _this$props.rippleY,
	          rippleSize = _this$props.rippleSize,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
	      var _this$state = this.state,
	          visible = _this$state.visible,
	          leaving = _this$state.leaving;
	      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
	      var rippleStyles = {
	        width: rippleSize,
	        height: rippleSize,
	        top: -(rippleSize / 2) + rippleY,
	        left: -(rippleSize / 2) + rippleX
	      };
	      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onExit: this.handleExit
	      }, other), _react.default.createElement("span", {
	        className: rippleClassName,
	        style: rippleStyles
	      }, _react.default.createElement("span", {
	        className: childClassName
	      })));
	    }
	  }]);
	  return Ripple;
	}(_react.default.Component);
	
	Ripple.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number
	} : {};
	Ripple.defaultProps = {
	  pulsate: false
	};
	var _default = Ripple;
	exports.default = _default;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(86));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(300));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(202));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      position: 'absolute',
	      overflow: 'hidden',
	      borderRadius: 'inherit',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      pointerEvents: 'none',
	      zIndex: 0
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      width: 50,
	      height: 50,
	      left: 0,
	      top: 0,
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes mui-ripple-enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes mui-ripple-exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes mui-ripple-pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var TouchRipple =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  (0, _inherits2.default)(TouchRipple, _React$PureComponent);
	
	  function TouchRipple() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, TouchRipple);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.ignoringMouseDown = false;
	    _this.startTimer = null;
	    _this.startTimerCommit = null;
	    _this.state = {
	      // eslint-disable-next-line react/no-unused-state
	      nextKey: 0,
	      ripples: []
	    };
	
	    _this.pulsate = function () {
	      _this.start({}, {
	        pulsate: true
	      });
	    };
	
	    _this.start = function () {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var cb = arguments.length > 2 ? arguments[2] : undefined;
	      var _options$pulsate = options.pulsate,
	          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	          _options$center = options.center,
	          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
	          _options$fakeElement = options.fakeElement,
	          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
	        _this.ignoringMouseDown = false;
	        return;
	      }
	
	      if (event.type === 'touchstart') {
	        _this.ignoringMouseDown = true;
	      }
	
	      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	      var rect = element ? element.getBoundingClientRect() : {
	        width: 0,
	        height: 0,
	        left: 0,
	        top: 0
	      }; // Get the size of the ripple
	
	      var rippleX;
	      var rippleY;
	      var rippleSize;
	
	      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	        rippleX = Math.round(rect.width / 2);
	        rippleY = Math.round(rect.height / 2);
	      } else {
	        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	        rippleX = Math.round(clientX - rect.left);
	        rippleY = Math.round(clientY - rect.top);
	      }
	
	      if (center) {
	        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	        if (rippleSize % 2 === 0) {
	          rippleSize += 1;
	        }
	      } else {
	        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	      } // Touche devices
	
	
	      if (event.touches) {
	        // Prepare the ripple effect.
	        _this.startTimerCommit = function () {
	          _this.startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Deplay the execution of the ripple effect.
	
	
	        _this.startTimer = setTimeout(function () {
	          if (_this.startTimerCommit) {
	            _this.startTimerCommit();
	
	            _this.startTimerCommit = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      } else {
	        _this.startCommit({
	          pulsate: pulsate,
	          rippleX: rippleX,
	          rippleY: rippleY,
	          rippleSize: rippleSize,
	          cb: cb
	        });
	      }
	    };
	
	    _this.startCommit = function (params) {
	      var pulsate = params.pulsate,
	          rippleX = params.rippleX,
	          rippleY = params.rippleY,
	          rippleSize = params.rippleSize,
	          cb = params.cb;
	
	      _this.setState(function (state) {
	        return {
	          nextKey: state.nextKey + 1,
	          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
	            key: state.nextKey,
	            classes: _this.props.classes,
	            timeout: {
	              exit: DURATION,
	              enter: DURATION
	            },
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize
	          })])
	        };
	      }, cb);
	    };
	
	    _this.stop = function (event, cb) {
	      clearTimeout(_this.startTimer);
	      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
	      // We still want to show ripple effect.
	
	      if (event.type === 'touchend' && _this.startTimerCommit) {
	        event.persist();
	
	        _this.startTimerCommit();
	
	        _this.startTimerCommit = null;
	        _this.startTimer = setTimeout(function () {
	          _this.stop(event, cb);
	        }, 0);
	        return;
	      }
	
	      _this.startTimerCommit = null;
	
	      if (ripples && ripples.length) {
	        _this.setState({
	          ripples: ripples.slice(1)
	        }, cb);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(TouchRipple, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.startTimer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          center = _this$props.center,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
	      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
	        component: "span",
	        enter: true,
	        exit: true,
	        className: (0, _classnames.default)(classes.root, className)
	      }, other), this.state.ripples);
	    }
	  }]);
	  return TouchRipple;
	}(_react.default.PureComponent);
	
	TouchRipple.propTypes =  false ? {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	TouchRipple.defaultProps = {
	  center: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(TouchRipple);
	
	exports.default = _default;

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function createRippleHandler(instance, eventName, action, cb) {
	  return function handleEvent(event) {
	    if (cb) {
	      cb.call(instance, event);
	    }
	
	    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.
	
	    if (event.defaultPrevented) {
	      ignore = true;
	    }
	
	    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
	      ignore = true;
	    }
	
	    if (!ignore && instance.ripple) {
	      instance.ripple[action](event);
	    }
	
	    if (typeof instance.props["on".concat(eventName)] === 'function') {
	      instance.props["on".concat(eventName)](event);
	    }
	
	    return true;
	  };
	}
	
	var _default = createRippleHandler;
	exports.default = _default;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectFocusVisible = detectFocusVisible;
	exports.listenForFocusKeys = listenForFocusKeys;
	
	var _keycode = _interopRequireDefault(__webpack_require__(57));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	var internal = {
	  focusKeyPressed: false,
	  keyUpEventTimeout: -1
	};
	
	function detectFocusVisible(instance, element, callback) {
	  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
	   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
	  instance.focusVisibleTimeout = setTimeout(function () {
	    var doc = (0, _ownerDocument.default)(element);
	
	    if (internal.focusKeyPressed && (doc.activeElement === element || element.contains(doc.activeElement))) {
	      callback();
	    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
	      detectFocusVisible(instance, element, callback, attempt + 1);
	    }
	  }, instance.focusVisibleCheckTime);
	}
	
	var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];
	
	function isFocusKey(event) {
	  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
	}
	
	var handleKeyUpEvent = function handleKeyUpEvent(event) {
	  if (isFocusKey(event)) {
	    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.
	
	    clearTimeout(internal.keyUpEventTimeout);
	    internal.keyUpEventTimeout = setTimeout(function () {
	      internal.focusKeyPressed = false;
	    }, 1e3);
	  }
	};
	
	function listenForFocusKeys(win) {
	  // The event listener will only be added once per window.
	  // Duplicate event listeners will be ignored by addEventListener.
	  // Also, this logic is client side only, we don't need a teardown.
	  win.addEventListener('keyup', handleKeyUpEvent);
	}

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(201));

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _helpers = __webpack_require__(61);
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block',
	      lineHeight: 1 // Keep the progress centered
	
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {},
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes mui-progress-circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes mui-progress-circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-120px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function CircularProgress(props) {
	  var _classNames, _classNames2;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      style = props.style,
	      thickness = props.thickness,
	      value = props.value,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    role: "progressbar"
	  }, rootProps, other), _react.default.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, _react.default.createElement("circle", {
	    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	}
	
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
	
	  /**
	   * The size of the circle.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : {};
	CircularProgress.defaultProps = {
	  color: 'primary',
	  size: 40,
	  thickness: 3.6,
	  value: 0,
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(492));

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(149));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	// @inheritedComponent EventListener
	
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	var ClickAwayListener =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ClickAwayListener, _React$Component);
	
	  function ClickAwayListener() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.node = null;
	    _this.mounted = null;
	
	    _this.handleClickAway = function (event) {
	      // Ignore events that have been `event.preventDefault()` marked.
	      if (event.defaultPrevented) {
	        return;
	      } // IE11 support, which trigger the handleClickAway even after the unbind
	
	
	      if (!_this.mounted) {
	        return;
	      } // The child might render null.
	
	
	      if (!_this.node) {
	        return;
	      }
	
	      var doc = (0, _ownerDocument.default)(_this.node);
	
	      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
	        _this.props.onClickAway(event);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ClickAwayListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Finds the first child when a component returns a fragment.
	      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
	      this.node = _reactDom.default.findDOMNode(this);
	      this.mounted = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          mouseEvent = _this$props.mouseEvent,
	          touchEvent = _this$props.touchEvent,
	          onClickAway = _this$props.onClickAway,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
	      var listenerProps = {};
	
	      if (mouseEvent !== false) {
	        listenerProps[mouseEvent] = this.handleClickAway;
	      }
	
	      if (touchEvent !== false) {
	        listenerProps[touchEvent] = this.handleClickAway;
	      }
	
	      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
	        target: "document"
	      }, listenerProps, other), children);
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.default.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
	} : {};
	ClickAwayListener.defaultProps = {
	  mouseEvent: 'onMouseUp',
	  touchEvent: 'onTouchEnd'
	};
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(494));

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(110);
	
	var _exactProp = _interopRequireDefault(__webpack_require__(112));
	
	/* eslint-disable react/no-unused-prop-types */
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased',
	        // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale',
	        // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      body: {
	        margin: 0,
	        // Remove the margin in all browsers.
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        }
	      }
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	var CssBaseline =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(CssBaseline, _React$Component);
	
	  function CssBaseline() {
	    (0, _classCallCheck2.default)(this, CssBaseline);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CssBaseline).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(CssBaseline, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return CssBaseline;
	}(_react.default.Component);
	
	CssBaseline.propTypes =  false ? {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : {};
	CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes) : {};
	CssBaseline.defaultProps = {
	  children: null
	};
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(495));

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(106));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(111));
	
	var _utils = __webpack_require__(152);
	
	// @inheritedComponent Transition
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    // Use translateZ to scrolling issue on Chrome.
	    transform: "".concat(getScale(1), " translateZ(0)")
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/demos/tooltips) and
	 * [Popover](/utils/popover) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Grow, _React$Component);
	
	  function Grow() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Grow);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.autoTimeout = null;
	    _this.timer = null;
	
	    _this.handleEnter = function (node) {
	      var _this$props = _this.props,
	          theme = _this$props.theme,
	          timeout = _this$props.timeout;
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration,
	          delay = _getTransitionProps.delay;
	
	      var duration = 0;
	
	      if (timeout === 'auto') {
	        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	        _this.autoTimeout = duration;
	      } else {
	        duration = transitionDuration;
	      }
	
	      node.style.transition = [theme.transitions.create('opacity', {
	        duration: duration,
	        delay: delay
	      }), theme.transitions.create('transform', {
	        duration: duration * 0.666,
	        delay: delay
	      })].join(',');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    };
	
	    _this.handleExit = function (node) {
	      var _this$props2 = _this.props,
	          theme = _this$props2.theme,
	          timeout = _this$props2.timeout;
	      var duration = 0;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration,
	          delay = _getTransitionProps2.delay;
	
	      if (timeout === 'auto') {
	        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	        _this.autoTimeout = duration;
	      } else {
	        duration = transitionDuration;
	      }
	
	      node.style.transition = [theme.transitions.create('opacity', {
	        duration: duration,
	        delay: delay
	      }), theme.transitions.create('transform', {
	        duration: duration * 0.666,
	        delay: delay || duration * 0.333
	      })].join(',');
	      node.style.opacity = '0';
	      node.style.transform = getScale(0.75);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.addEndListener = function (_, next) {
	      if (_this.props.timeout === 'auto') {
	        _this.timer = setTimeout(next, _this.autoTimeout || 0);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Grow, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          onEnter = _this$props3.onEnter,
	          onExit = _this$props3.onExit,
	          styleProp = _this$props3.style,
	          theme = _this$props3.theme,
	          timeout = _this$props3.timeout,
	          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
	      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        appear: true,
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        addEndListener: this.addEndListener,
	        timeout: timeout === 'auto' ? null : timeout
	      }, other), function (state, childProps) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          style: (0, _extends2.default)({
	            opacity: 0,
	            transform: getScale(0.75)
	          }, styles[state], style)
	        }, childProps));
	      });
	    }
	  }]);
	  return Grow;
	}(_react.default.Component);
	
	Grow.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Grow.defaultProps = {
	  timeout: 'auto'
	};
	Grow.muiSupportAuto = true;
	
	var _default = (0, _withTheme.default)()(Grow);
	
	exports.default = _default;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(207));

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(217);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(148));
	
	var _helpers = __webpack_require__(61);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: 48,
	      height: 48,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
	    centerRipple: true,
	    focusRipple: true,
	    disabled: disabled
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes.default.bool
	} : {};
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(505));

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
	  dense: {
	    paddingTop: 4,
	    paddingBottom: 4
	  },
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	
	var List =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(List, _React$Component);
	
	  function List() {
	    (0, _classCallCheck2.default)(this, List);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(List).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(List, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          Component = _this$props.component,
	          dense = _this$props.dense,
	          disablePadding = _this$props.disablePadding,
	          subheader = _this$props.subheader,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: className
	      }, other), subheader, children);
	    }
	  }]);
	  return List;
	}(_react.default.Component);
	
	List.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items. The property is available to descendant components as the
	   * `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : {};
	List.defaultProps = {
	  component: 'ul',
	  dense: false,
	  disablePadding: false
	};
	List.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(210));

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(148));
	
	var _reactHelpers = __webpack_require__(218);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	    // TODO: Sanity check this - why is focusVisibleClassName prop apparently applied to a div?
	
	    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
	    focusVisible: {
	      backgroundColor: theme.palette.action.hover
	    },
	
	    /* Legacy styles applied to the root element. Use `root` instead. */
	    default: {},
	
	    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
	    dense: {
	      paddingTop: 8,
	      paddingBottom: 8
	    },
	
	    /* Styles applied to the inner `component` element if `disabled={true}`. */
	    disabled: {
	      opacity: 0.5
	    },
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: theme.mixins.gutters(),
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: 32
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck2.default)(this, ListItem);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListItem).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(ListItem, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          button = _this$props.button,
	          childrenProp = _this$props.children,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          componentProp = _this$props.component,
	          ContainerComponent = _this$props.ContainerComponent,
	          _this$props$Container = _this$props.ContainerProps;
	      _this$props$Container = _this$props$Container === void 0 ? {} : _this$props$Container;
	      var ContainerClassName = _this$props$Container.className,
	          ContainerProps = (0, _objectWithoutProperties2.default)(_this$props$Container, ["className"]),
	          dense = _this$props.dense,
	          disabled = _this$props.disabled,
	          disableGutters = _this$props.disableGutters,
	          divider = _this$props.divider,
	          focusVisibleClassName = _this$props.focusVisibleClassName,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
	      var isDense = dense || this.context.dense || false;
	
	      var children = _react.default.Children.toArray(childrenProp);
	
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	      var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, isDense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	      var componentProps = (0, _extends2.default)({
	        className: className,
	        disabled: disabled
	      }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
	        Component = _ButtonBase.default;
	      }
	
	      if (hasSecondaryAction) {
	        // Use div by default.
	        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	        if (ContainerComponent === 'li') {
	          if (Component === 'li') {
	            Component = 'div';
	          } else if (componentProps.component === 'li') {
	            componentProps.component = 'div';
	          }
	        }
	
	        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, ContainerClassName)
	        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
	      }
	
	      return _react.default.createElement(Component, componentProps, children);
	    }
	  }]);
	  return ListItem;
	}(_react.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : {};
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	ListItem.contextTypes = {
	  dense: _propTypes.default.bool
	};
	ListItem.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(509));

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(510));
	
	// @inheritedComponent ListItem
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.subheading, {
	      height: 24,
	      boxSizing: 'content-box',
	      width: 'auto',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      paddingLeft: 16,
	      paddingRight: 16,
	      '&$selected': {
	        backgroundColor: theme.palette.action.selected
	      }
	    }),
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	
	function MenuItem(props) {
	  var classes = props.classes,
	      className = props.className,
	      component = props.component,
	      selected = props.selected,
	      role = props.role,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
	  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
	    button: true,
	    role: role,
	    tabIndex: -1,
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
	    component: component
	  }, other));
	}
	
	MenuItem.propTypes =  false ? {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : {};
	MenuItem.defaultProps = {
	  component: 'li',
	  role: 'menuitem',
	  selected: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(512));

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _keycode = _interopRequireDefault(__webpack_require__(57));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	var _List = _interopRequireDefault(__webpack_require__(211));
	
	// @inheritedComponent List
	var MenuList =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(MenuList, _React$Component);
	
	  function MenuList() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, MenuList);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.listRef = null;
	    _this.selectedItemRef = null;
	    _this.blurTimer = null;
	    _this.state = {
	      currentTabIndex: null
	    };
	
	    _this.handleBlur = function (event) {
	      _this.blurTimer = setTimeout(function () {
	        if (_this.listRef) {
	          var list = _this.listRef;
	          var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	          if (!list.contains(currentFocus)) {
	            _this.resetTabIndex();
	          }
	        }
	      }, 30);
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      var list = _this.listRef;
	      var key = (0, _keycode.default)(event);
	      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
	        if (_this.selectedItemRef) {
	          _this.selectedItemRef.focus();
	        } else {
	          list.firstChild.focus();
	        }
	      } else if (key === 'down') {
	        event.preventDefault();
	
	        if (currentFocus.nextElementSibling) {
	          currentFocus.nextElementSibling.focus();
	        }
	      } else if (key === 'up') {
	        event.preventDefault();
	
	        if (currentFocus.previousElementSibling) {
	          currentFocus.previousElementSibling.focus();
	        }
	      }
	
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(event, key);
	      }
	    };
	
	    _this.handleItemFocus = function (event) {
	      var list = _this.listRef;
	
	      if (list) {
	        for (var i = 0; i < list.children.length; i += 1) {
	          if (list.children[i] === event.currentTarget) {
	            _this.setTabIndex(i);
	
	            break;
	          }
	        }
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(MenuList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resetTabIndex();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.blurTimer);
	    }
	  }, {
	    key: "setTabIndex",
	    value: function setTabIndex(index) {
	      this.setState({
	        currentTabIndex: index
	      });
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var currentTabIndex = this.state.currentTabIndex;
	      var list = this.listRef;
	
	      if (!list || !list.children || !list.firstChild) {
	        return;
	      }
	
	      if (currentTabIndex && currentTabIndex >= 0) {
	        list.children[currentTabIndex].focus();
	      } else {
	        list.firstChild.focus();
	      }
	    }
	  }, {
	    key: "resetTabIndex",
	    value: function resetTabIndex() {
	      var list = this.listRef;
	      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	      var items = [];
	
	      for (var i = 0; i < list.children.length; i += 1) {
	        items.push(list.children[i]);
	      }
	
	      var currentFocusIndex = items.indexOf(currentFocus);
	
	      if (currentFocusIndex !== -1) {
	        return this.setTabIndex(currentFocusIndex);
	      }
	
	      if (this.selectedItemRef) {
	        return this.setTabIndex(items.indexOf(this.selectedItemRef));
	      }
	
	      return this.setTabIndex(0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          onBlur = _this$props.onBlur,
	          onKeyDown = _this$props.onKeyDown,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown"]);
	      return _react.default.createElement(_List.default, (0, _extends2.default)({
	        role: "menu",
	        ref: function ref(_ref) {
	          _this2.listRef = _reactDom.default.findDOMNode(_ref);
	        },
	        className: className,
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleBlur
	      }, other), _react.default.Children.map(children, function (child, index) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
	        return _react.default.cloneElement(child, {
	          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
	          ref: child.props.selected ? function (ref) {
	            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
	          } : undefined,
	          onFocus: _this2.handleItemFocus
	        });
	      }));
	    }
	  }]);
	  return MenuList;
	}(_react.default.Component);
	
	MenuList.propTypes =  false ? {
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func
	} : {};
	var _default = MenuList;
	exports.default = _default;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(213));

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	
	function Paper(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      square = props.square,
	      elevation = props.elevation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
	   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
	  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	Paper.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It's accepting values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool
	} : {};
	Paper.defaultProps = {
	  component: 'div',
	  elevation: 2,
	  square: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(214));

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _helpers = __webpack_require__(61);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: 24,
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="saction"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function SvgIcon(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      Component = props.component,
	      fontSize = props.fontSize,
	      nativeColor = props.nativeColor,
	      titleAccess = props.titleAccess,
	      viewBox = props.viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fontSizeInherit, fontSize === 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), _classNames), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className,
	    focusable: "false",
	    viewBox: viewBox,
	    color: nativeColor,
	    "aria-hidden": titleAccess ? 'false' : 'true'
	  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
	}
	
	SvgIcon.propTypes =  false ? {
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  nativeColor: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : {};
	SvgIcon.defaultProps = {
	  color: 'inherit',
	  component: 'svg',
	  fontSize: 'default',
	  viewBox: '0 0 24 24'
	};
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(215));

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(6));
	var _createClass = _interopDefault(__webpack_require__(7));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(10));
	var _getPrototypeOf = _interopDefault(__webpack_require__(8));
	var _inherits = _interopDefault(__webpack_require__(9));
	var _typeof = _interopDefault(__webpack_require__(87));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(12));
	var _extends = _interopDefault(__webpack_require__(5));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(3));
	var warning = _interopDefault(__webpack_require__(14));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _extends({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(EventListener, _React$PureComponent);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.applyListeners(off, prevProps);
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var target = props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.PureComponent);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(15);
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _brcast = _interopRequireDefault(__webpack_require__(336));
	
	var _themeListener = _interopRequireWildcard(__webpack_require__(151));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(112));
	
	/**
	 * This component takes a `theme` property.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	var MuiThemeProvider =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(MuiThemeProvider, _React$Component);
	
	  // We are not using the React state in order to avoid unnecessary rerender.
	  function MuiThemeProvider(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, MuiThemeProvider);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProvider).call(this)); // Get the outer theme from the context, can be null
	
	    _this.broadcast = (0, _brcast.default)();
	    _this.unsubscribeId = null;
	    _this.outerTheme = null;
	    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children
	
	    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(MuiThemeProvider, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _ref;
	
	      var _this$props = this.props,
	          sheetsManager = _this$props.sheetsManager,
	          disableStylesGeneration = _this$props.disableStylesGeneration;
	      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};
	
	      if (sheetsManager !== undefined) {
	        muiThemeProviderOptions.sheetsManager = sheetsManager;
	      }
	
	      if (disableStylesGeneration !== undefined) {
	        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
	      }
	
	      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Subscribe on the outer theme, if present
	      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
	        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children
	
	        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Propagate a local theme update
	      if (this.props.theme !== prevProps.theme) {
	        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribeId !== null) {
	        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
	      }
	    } // Simple merge between the outer theme and the local theme
	
	  }, {
	    key: "mergeOuterLocalTheme",
	    value: function mergeOuterLocalTheme(localTheme) {
	      // To support composition of theme.
	      if (typeof localTheme === 'function') {
	         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
	        return localTheme(this.outerTheme);
	      }
	
	      if (!this.outerTheme) {
	        return localTheme;
	      }
	
	      return (0, _extends2.default)({}, this.outerTheme, localTheme);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // TODO move the sheetsManager property to a different component.
	      // warning(
	      //   typeof window !== 'undefined' || this.props.sheetsManager,
	      //   [
	      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
	      //       'when rendering on the server.',
	      //     'If you do not, you might experience a memory leak',
	      //   ].join('\n'),
	      // );
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.default.Component);
	
	MuiThemeProvider.propTypes =  false ? {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server side.
	   * You can significantly speed up the traversal with this property.
	   */
	  disableStylesGeneration: _propTypes.default.bool,
	
	  /**
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * A theme object.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : {};
	MuiThemeProvider.propTypes =  false ? (0, _exactProp.default)(MuiThemeProvider.propTypes) : {};
	MuiThemeProvider.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
	  muiThemeProviderOptions: _propTypes.default.object
	});
	MuiThemeProvider.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
	  muiThemeProviderOptions: _propTypes.default.object
	});
	var _default = MuiThemeProvider;
	exports.default = _default;

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _MuiThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(314));
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(150));
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(315));
	
	var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(533));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(537));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(111));

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(12));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(8));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(128));
	
	var _wrapDisplayName = _interopRequireDefault(__webpack_require__(85));
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(150));
	
	var _themeListener = _interopRequireDefault(__webpack_require__(151));
	
	var defaultTheme;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme.default)();
	  return defaultTheme;
	} // Provide the theme object as a property to the input component.
	
	
	var withTheme = function withTheme() {
	  return function (Component) {
	    var WithTheme =
	    /*#__PURE__*/
	    function (_React$Component) {
	      (0, _inherits2.default)(WithTheme, _React$Component);
	
	      function WithTheme(props, context) {
	        var _this;
	
	        (0, _classCallCheck2.default)(this, WithTheme);
	        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
	        _this.unsubscribeId = null;
	        _this.state = {};
	        _this.state = {
	          // We use || as the function call is lazy evaluated.
	          theme: _themeListener.default.initial(context) || getDefaultTheme()
	        };
	        return _this;
	      }
	
	      (0, _createClass2.default)(WithTheme, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
	            _this2.setState({
	              theme: theme
	            });
	          });
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          if (this.unsubscribeId !== null) {
	            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          var _this$props = this.props,
	              innerRef = _this$props.innerRef,
	              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
	          return _react.default.createElement(Component, (0, _extends2.default)({
	            theme: this.state.theme,
	            ref: innerRef
	          }, other));
	        }
	      }]);
	      return WithTheme;
	    }(_react.default.Component);
	
	    WithTheme.propTypes =  false ? {
	      /**
	       * Use that property to pass a ref callback to the decorated component.
	       */
	      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
	    } : {};
	    WithTheme.contextTypes = _themeListener.default.contextTypes;
	
	    if (false) {
	      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	};
	
	var _default = withTheme;
	exports.default = _default;

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
	    delay: style.transitionDelay
	  };
	}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  /* istanbul ignore if */
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}
	
	var _default = exactProp;
	exports.default = _default;

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalize = capitalize;
	exports.contains = contains;
	exports.findIndex = findIndex;
	exports.find = find;
	exports.createChainedFunction = createChainedFunction;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(87));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	function capitalize(string) {
	  if (false) {
	    throw new Error('Material-UI: capitalize(string) expects a string argument.');
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	function contains(obj, pred) {
	  return Object.keys(pred).every(function (key) {
	    return obj.hasOwnProperty(key) && obj[key] === pred[key];
	  });
	}
	
	function findIndex(arr, pred) {
	  var predType = (0, _typeof2.default)(pred);
	
	  for (var i = 0; i < arr.length; i += 1) {
	    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
	      return i;
	    }
	
	    if (predType === 'object' && contains(arr[i], pred)) {
	      return i;
	    }
	
	    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
	      return arr.indexOf(pred);
	    }
	  }
	
	  return -1;
	}
	
	function find(arr, pred) {
	  var index = findIndex(arr, pred);
	  return index > -1 ? arr[index] : undefined;
	}
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	
	
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	var _default = ownerDocument;
	exports.default = _default;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	function ownerWindow(node) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || doc.parentView || fallback;
	}
	
	var _default = ownerWindow;
	exports.default = _default;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElementWithClassName = cloneElementWithClassName;
	exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
	exports.isMuiElement = isMuiElement;
	exports.isMuiComponent = isMuiComponent;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	/* eslint-disable import/prefer-default-export */
	function cloneElementWithClassName(child, className) {
	  return _react.default.cloneElement(child, {
	    className: (0, _classnames.default)(child.props.className, className)
	  });
	}
	
	function cloneChildrenWithClassName(children, className) {
	  return _react.default.Children.map(children, function (child) {
	    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
	  });
	}
	
	function isMuiElement(element, muiNames) {
	  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}
	
	function isMuiComponent(element, muiNames) {
	  return muiNames.indexOf(element.muiName) !== -1;
	}

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	})), 'ArrowUpward');
	
	exports.default = _default;

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	})), 'Close');
	
	exports.default = _default;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
	})), 'ExpandLess');
	
	exports.default = _default;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	})), 'FilterList');
	
	exports.default = _default;

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
	})), 'FormatSize');
	
	exports.default = _default;

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
	})), 'Fullscreen');
	
	exports.default = _default;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
	})), 'FullscreenExit');
	
	exports.default = _default;

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
	})), 'Home');
	
	exports.default = _default;

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	})), 'MoreVert');
	
	exports.default = _default;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(44));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	})), 'Search');
	
	exports.default = _default;

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(40);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _pure = _interopRequireDefault(__webpack_require__(304));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(216));
	
	function createSvgIcon(path, displayName) {
	  var Icon = function Icon(props) {
	    return _react.default.createElement(_SvgIcon.default, props, path);
	  };
	
	  Icon.displayName = displayName;
	  Icon = (0, _pure.default)(Icon);
	  Icon.muiName = 'SvgIcon';
	  return Icon;
	}
	
	;
	var _default = createSvgIcon;
	exports.default = _default;

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(339);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var v;
	
		if (max === 0) {
			s = 0;
		} else {
			s = (delta / max * 1000) / 10;
		}
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		v = ((max / 255) * 1000) / 10;
	
		return [h, s, v];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(338);
	var route = __webpack_require__(648);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(338);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var colorString = __webpack_require__(649);
	var convert = __webpack_require__(647);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (!obj) {
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		isDark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		isLight: function () {
			return !this.isDark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			var color1 = mixinColor.rgb();
			var color2 = this.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(339);
	var swizzle = __webpack_require__(1225);
	
	var reverseNames = {};
	
	// create a list of reverse color names
	for (var name in colorNames) {
		if (colorNames.hasOwnProperty(name)) {
			reverseNames[colorNames[name]] = name;
		}
	}
	
	var cs = module.exports = {
		to: {}
	};
	
	cs.get = function (string) {
		var prefix = string.substring(0, 3).toLowerCase();
		var val;
		var model;
		switch (prefix) {
			case 'hsl':
				val = cs.get.hsl(string);
				model = 'hsl';
				break;
			case 'hwb':
				val = cs.get.hwb(string);
				model = 'hwb';
				break;
			default:
				val = cs.get.rgb(string);
				model = 'rgb';
				break;
		}
	
		if (!val) {
			return null;
		}
	
		return {model: model, value: val};
	};
	
	cs.get.rgb = function (string) {
		if (!string) {
			return null;
		}
	
		var abbr = /^#([a-f0-9]{3,4})$/i;
		var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
		var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var keyword = /(\D+)/;
	
		var rgb = [0, 0, 0, 1];
		var match;
		var i;
		var hexAlpha;
	
		if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
	
			for (i = 0; i < 3; i++) {
				// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
				var i2 = i * 2;
				rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(abbr)) {
			match = match[1];
			hexAlpha = match[3];
	
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(rgba)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i + 1], 0);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(per)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(keyword)) {
			if (match[1] === 'transparent') {
				return [0, 0, 0, 0];
			}
	
			rgb = colorNames[match[1]];
	
			if (!rgb) {
				return null;
			}
	
			rgb[3] = 1;
	
			return rgb;
		} else {
			return null;
		}
	
		for (i = 0; i < 3; i++) {
			rgb[i] = clamp(rgb[i], 0, 255);
		}
		rgb[3] = clamp(rgb[3], 0, 1);
	
		return rgb;
	};
	
	cs.get.hsl = function (string) {
		if (!string) {
			return null;
		}
	
		var hsl = /^hsla?\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hsl);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var s = clamp(parseFloat(match[2]), 0, 100);
			var l = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	
			return [h, s, l, a];
		}
	
		return null;
	};
	
	cs.get.hwb = function (string) {
		if (!string) {
			return null;
		}
	
		var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hwb);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var w = clamp(parseFloat(match[2]), 0, 100);
			var b = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	
		return null;
	};
	
	cs.to.hex = function () {
		var rgba = swizzle(arguments);
	
		return (
			'#' +
			hexDouble(rgba[0]) +
			hexDouble(rgba[1]) +
			hexDouble(rgba[2]) +
			(rgba[3] < 1
				? (hexDouble(Math.round(rgba[3] * 255)))
				: '')
		);
	};
	
	cs.to.rgb = function () {
		var rgba = swizzle(arguments);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
			: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
	};
	
	cs.to.rgb.percent = function () {
		var rgba = swizzle(arguments);
	
		var r = Math.round(rgba[0] / 255 * 100);
		var g = Math.round(rgba[1] / 255 * 100);
		var b = Math.round(rgba[2] / 255 * 100);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
			: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
	};
	
	cs.to.hsl = function () {
		var hsla = swizzle(arguments);
		return hsla.length < 4 || hsla[3] === 1
			? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
			: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
	};
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	cs.to.hwb = function () {
		var hwba = swizzle(arguments);
	
		var a = '';
		if (hwba.length >= 4 && hwba[3] !== 1) {
			a = ', ' + hwba[3];
		}
	
		return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
	};
	
	cs.to.keyword = function (rgb) {
		return reverseNames[rgb.slice(0, 3)];
	};
	
	// helpers
	function clamp(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
		var str = num.toString(16).toUpperCase();
		return (str.length < 2) ? '0' + str : str;
	}


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var PopperJS = _interopDefault(__webpack_require__(985));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.propTypes = {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled,
	          positionFixed = _props.positionFixed;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        positionFixed: positionFixed,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          positionFixed = _props2.positionFixed,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  positionFixed: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  positionFixed: false,
	  modifiers: {}
	};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(307);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(306);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(146);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(85);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(305);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(378);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(146);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(85);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v3.3.3 - 2018-09-04
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),

/***/ 1225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayish = __webpack_require__(1226);
	
	var concat = Array.prototype.concat;
	var slice = Array.prototype.slice;
	
	var swizzle = module.exports = function swizzle(args) {
		var results = [];
	
		for (var i = 0, len = args.length; i < len; i++) {
			var arg = args[i];
	
			if (isArrayish(arg)) {
				// http://jsperf.com/javascript-array-concat-vs-push/98
				results = concat.call(results, slice.call(arg));
			} else {
				results.push(arg);
			}
		}
	
		return results;
	};
	
	swizzle.wrap = function (fn) {
		return function () {
			return fn(swizzle(arguments));
		};
	};


/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isArrayish(obj) {
		if (!obj || typeof obj === 'string') {
			return false;
		}
	
		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && (obj.splice instanceof Function ||
				(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
	};


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(48);
	
	var _screenfull = __webpack_require__(1219);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _Home = __webpack_require__(553);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Search = __webpack_require__(555);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _ArrowUpward = __webpack_require__(545);
	
	var _ArrowUpward2 = _interopRequireDefault(_ArrowUpward);
	
	var _Fullscreen = __webpack_require__(551);
	
	var _Fullscreen2 = _interopRequireDefault(_Fullscreen);
	
	var _FullscreenExit = __webpack_require__(552);
	
	var _FullscreenExit2 = _interopRequireDefault(_FullscreenExit);
	
	var _store = __webpack_require__(45);
	
	var _shared = __webpack_require__(74);
	
	var _FontSetter = __webpack_require__(590);
	
	var _FontSetter2 = _interopRequireDefault(_FontSetter);
	
	var _CategoryFilter = __webpack_require__(589);
	
	var _CategoryFilter2 = _interopRequireDefault(_CategoryFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _actionsBar, _group;
	
	  return {
	    actionsBar: (_actionsBar = {
	      position: 'absolute',
	      background: theme.bars.colors.background,
	      left: 0,
	      //top: `calc(100vh - ${theme.bars.sizes.actionsBar}px)`,
	      bottom: 0,
	      display: 'flex',
	      flexDirection: 'row',
	      padding: '0 ' + theme.base.sizes.linesMargin,
	      justifyContent: 'space-between',
	      height: theme.bars.sizes.actionsBar + 'px',
	      width: '100%',
	      '&::before': {
	        content: '""',
	        position: 'absolute',
	        left: theme.base.sizes.linesMargin,
	        right: theme.base.sizes.linesMargin,
	        height: 0,
	        top: 0,
	        borderTop: '1px solid ' + theme.base.colors.lines
	      }
	    }, _actionsBar['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {
	      padding: '0 calc(' + theme.base.sizes.linesMargin + ' * 1.5)'
	    }, _actionsBar['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      flexDirection: 'column',
	      top: 0,
	      right: 0,
	      left: 'auto',
	      height: '100%',
	      padding: theme.base.sizes.linesMargin + ' 0',
	      width: theme.bars.sizes.actionsBar + 'px',
	      '&::before': {
	        top: theme.base.sizes.linesMargin,
	        bottom: theme.base.sizes.linesMargin,
	        left: 0,
	        right: 'auto',
	        width: 0,
	        height: 'auto',
	        borderLeft: '1px solid ' + theme.base.colors.lines
	      }
	    }, _actionsBar),
	    group: (_group = {
	      display: 'flex',
	      flexDirection: 'row',
	      alignItems: 'center'
	    }, _group['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      flexDirection: 'column'
	    }, _group),
	    button: {
	      color: theme.bars.colors.icon
	    }
	  };
	};
	
	var ActionsBar = function (_React$Component) {
	  _inherits(ActionsBar, _React$Component);
	
	  function ActionsBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActionsBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fullscreen: false
	    }, _this.homeOnClick = _shared.featureNavigator.bind(_this), _this.searchOnClick = _shared.moveNavigatorAside.bind(_this), _this.fullscreenOnClick = function () {
	      if (_screenfull2.default.enabled) {
	        _screenfull2.default.toggle();
	      }
	    }, _this.arrowUpOnClick = function () {
	      _this.props.setScrollToTop(true);
	    }, _this.fontSetterOnClick = function (val) {
	      _this.props.setFontSizeIncrease(val);
	
	      if (typeof localStorage !== 'undefined') {
	        localStorage.setItem('font-size-increase', val);
	      }
	    }, _this.categoryFilterOnClick = function (val) {
	      _this.props.setCategoryFilter(val);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ActionsBar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (_screenfull2.default.enabled) {
	      _screenfull2.default.on('change', function () {
	        _this2.setState({
	          fullscreen: _screenfull2.default.isFullscreen
	        });
	      });
	    }
	  };
	
	  ActionsBar.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        navigatorPosition = _props.navigatorPosition,
	        navigatorShape = _props.navigatorShape,
	        isWideScreen = _props.isWideScreen,
	        categories = _props.categories;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: classes.actionsBar },
	      _react2.default.createElement(
	        'div',
	        { className: classes.group },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            'aria-label': 'Back to list',
	            onClick: this.homeOnClick,
	            title: 'Back to the list',
	            className: classes.button
	          },
	          _react2.default.createElement(_Home2.default, null)
	        ),
	        (isWideScreen && navigatorShape === 'open' || navigatorPosition !== 'is-aside') && _react2.default.createElement(_CategoryFilter2.default, { categories: categories, filterCategory: this.categoryFilterOnClick }),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            'aria-label': 'Search',
	            onClick: this.searchOnClick,
	            component: _gatsbyLink2.default,
	            'data-shape': 'closed',
	            to: '/search/',
	            title: 'Search',
	            className: classes.button
	          },
	          _react2.default.createElement(_Search2.default, { className: classes.button })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.group },
	        navigatorPosition === 'is-aside' && _react2.default.createElement(_FontSetter2.default, { increaseFont: this.fontSetterOnClick }),
	        _screenfull2.default.enabled && _react2.default.createElement(
	          _IconButton2.default,
	          {
	            'aria-label': 'Fullscreen',
	            onClick: this.fullscreenOnClick,
	            title: 'Fullscreen mode',
	            className: classes.button
	          },
	          this.state.fullscreen ? _react2.default.createElement(_FullscreenExit2.default, null) : _react2.default.createElement(_Fullscreen2.default, null)
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          { 'aria-label': 'Back to top', onClick: this.arrowUpOnClick, title: 'Scroll to top' },
	          _react2.default.createElement(_ArrowUpward2.default, { className: classes.button })
	        )
	      )
	    );
	  };
	
	  return ActionsBar;
	}(_react2.default.Component);
	
	ActionsBar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired,
	  setScrollToTop: _propTypes2.default.func.isRequired,
	  setFontSizeIncrease: _propTypes2.default.func.isRequired,
	  categories: _propTypes2.default.array.isRequired,
	  setCategoryFilter: _propTypes2.default.func.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    navigatorShape: state.navigatorShape,
	    isWideScreen: state.isWideScreen,
	    categoryFilter: state.categoryFilter
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape,
	  setScrollToTop: _store.setScrollToTop,
	  setFontSizeIncrease: _store.setFontSizeIncrease,
	  setCategoryFilter: _store.setCategoryFilter
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(ActionsBar));
	module.exports = exports['default'];

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _MenuItem = __webpack_require__(212);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuList = __webpack_require__(108);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _reactPopper = __webpack_require__(295);
	
	var _ClickAwayListener = __webpack_require__(206);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(107);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _Paper = __webpack_require__(109);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FilterList = __webpack_require__(549);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _fontSizeSetter;
	
	  return {
	    fontSizeSetter: (_fontSizeSetter = {}, _fontSizeSetter['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {}, _fontSizeSetter),
	    open: {
	      color: theme.bars.colors.icon
	    },
	    popperClose: {
	      pointerEvents: 'none'
	    },
	    popper: {
	      zIndex: 1
	    }
	  };
	};
	
	var CategoryFilter = function (_React$Component) {
	  _inherits(CategoryFilter, _React$Component);
	
	  function CategoryFilter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CategoryFilter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleClick = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _this.handleClose = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      _this.timeout = setTimeout(function () {
	        _this.setState({ open: false });
	      });
	    }, _this.handleFiltering = function (e) {
	      var category = e.target.innerText.trim();
	      _this.props.filterCategory(category);
	      _this.handleClose();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CategoryFilter.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  };
	
	  CategoryFilter.prototype.render = function render() {
	    var _classNames,
	        _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        categories = _props.categories;
	    var open = this.state.open;
	
	
	    return _react2.default.createElement(
	      'nav',
	      { className: classes.fontSizeSetter },
	      _react2.default.createElement(
	        _reactPopper.Manager,
	        null,
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              'aria-label': 'Filter by category',
	              'aria-haspopup': 'true',
	              onClick: this.handleClick,
	              title: 'Filter the list by category',
	              className: classes.open
	            },
	            _react2.default.createElement(_FilterList2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactPopper.Popper,
	          {
	            placement: 'bottom-end',
	            eventsEnabled: open,
	            className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames)) + ' ' + classes.popper
	          },
	          _react2.default.createElement(
	            _ClickAwayListener2.default,
	            { onClickAway: this.handleClose },
	            _react2.default.createElement(
	              _Grow2.default,
	              { 'in': open, id: 'cat-menu-list', style: { transformOrigin: '0 0 0' } },
	              _react2.default.createElement(
	                _Paper2.default,
	                null,
	                _react2.default.createElement(
	                  _MenuList2.default,
	                  { role: 'menu' },
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { key: 'all', onClick: this.handleFiltering },
	                    'all posts'
	                  ),
	                  categories.map(function (category) {
	                    return _react2.default.createElement(
	                      _MenuItem2.default,
	                      { key: category, onClick: _this2.handleFiltering },
	                      category
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return CategoryFilter;
	}(_react2.default.Component);
	
	CategoryFilter.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  categories: _propTypes2.default.array.isRequired,
	  filterCategory: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(CategoryFilter);
	module.exports = exports['default'];

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPopper = __webpack_require__(295);
	
	var _ClickAwayListener = __webpack_require__(206);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(107);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _Paper = __webpack_require__(109);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MenuItem = __webpack_require__(212);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuList = __webpack_require__(108);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _FormatSize = __webpack_require__(550);
	
	var _FormatSize2 = _interopRequireDefault(_FormatSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { MenuItem, MenuList } from "@material-ui/core/Menu";
	
	
	var styles = function styles(theme) {
	  var _fontSizeSetter;
	
	  return {
	    fontSizeSetter: (_fontSizeSetter = {}, _fontSizeSetter['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {}, _fontSizeSetter),
	    open: {
	      color: theme.bars.colors.icon
	    },
	    popperClose: {
	      pointerEvents: 'none'
	    }
	  };
	};
	
	var FontSetter = function (_React$Component) {
	  _inherits(FontSetter, _React$Component);
	
	  function FontSetter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FontSetter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      open: false
	    }, _this.handleClick = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _this.handleClose = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      _this.timeout = setTimeout(function () {
	        _this.setState({ open: false });
	      });
	    }, _this.handleSetting = function (e) {
	      var val = e.target.innerText.replace('%', '');
	      var factor = +val / 100;
	      _this.props.increaseFont(factor);
	      _this.handleClose();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FontSetter.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  };
	
	  FontSetter.prototype.render = function render() {
	    var _classNames;
	
	    var classes = this.props.classes;
	    var _state = this.state,
	        anchorEl = _state.anchorEl,
	        open = _state.open;
	
	
	    return _react2.default.createElement(
	      'nav',
	      { className: classes.fontSizeSetter },
	      _react2.default.createElement(
	        _reactPopper.Manager,
	        null,
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              'aria-label': 'Increase font size',
	              'aria-owns': anchorEl ? 'long-menu' : null,
	              'aria-haspopup': 'true',
	              onClick: this.handleClick,
	              title: 'Change font size',
	              className: classes.open
	            },
	            _react2.default.createElement(_FormatSize2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactPopper.Popper,
	          { placement: 'bottom-end', eventsEnabled: open, className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames)) },
	          _react2.default.createElement(
	            _ClickAwayListener2.default,
	            { onClickAway: this.handleClose },
	            _react2.default.createElement(
	              _Grow2.default,
	              { 'in': open, id: 'font-menu-list', style: { transformOrigin: '0 0 0' } },
	              _react2.default.createElement(
	                _Paper2.default,
	                null,
	                _react2.default.createElement(
	                  _MenuList2.default,
	                  { role: 'menu' },
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { onClick: this.handleSetting },
	                    '150%'
	                  ),
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { onClick: this.handleSetting },
	                    '125%'
	                  ),
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { onClick: this.handleSetting },
	                    '100%'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return FontSetter;
	}(_react2.default.Component);
	
	FontSetter.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  increaseFont: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(FontSetter);
	module.exports = exports['default'];

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ActionsBar = __webpack_require__(588);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ActionsBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Avatar = __webpack_require__(200);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(48);
	
	var _store = __webpack_require__(45);
	
	var _shared = __webpack_require__(74);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _avatar = __webpack_require__(197);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _TopMenu = __webpack_require__(597);
	
	var _TopMenu2 = _interopRequireDefault(_TopMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _infoBar;
	
	  return {
	    headerRow: {
	      display: 'flex',
	      alignItems: 'center',
	      height: '100%'
	    },
	    infoBar: (_infoBar = {
	      position: 'absolute',
	      background: theme.bars.colors.background,
	      top: 0,
	      left: 0,
	      width: '100%',
	      height: theme.bars.sizes.infoBar + 'px',
	      '&::before': {
	        content: '""',
	        position: 'absolute',
	        left: theme.base.sizes.linesMargin,
	        right: theme.base.sizes.linesMargin,
	        height: 0,
	        bottom: 0,
	        borderTop: '1px solid ' + theme.base.colors.lines
	      }
	    }, _infoBar['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      display: 'none'
	    }, _infoBar),
	    title: {
	      float: 'left',
	      margin: 'auto 0 auto 15px',
	      color: theme.bars.colors.text,
	      '& small': {
	        display: 'block',
	        fontSize: '.65em',
	        margin: '2px 0 0 0'
	      }
	    },
	    avatarLink: {
	      display: 'block',
	      float: 'left',
	      margin: '0 0 0 30px'
	    },
	    avatar: {
	      width: '36px',
	      borderRadius: '65% 75%',
	      border: '1px solid #ddd',
	      height: '36px'
	    }
	  };
	};
	
	var InfoBar = function (_React$Component) {
	  _inherits(InfoBar, _React$Component);
	
	  function InfoBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InfoBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.homeLinkOnClick = _shared.featureNavigator.bind(_this), _this.pageLinkOnClick = _shared.moveNavigatorAside.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  InfoBar.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        pages = _props.pages;
	
	
	    return _react2.default.createElement(
	      'aside',
	      { className: classes.infoBar },
	      _react2.default.createElement(
	        'div',
	        { className: classes.headerRow },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', className: classes.avatarLink, onClick: this.homeLinkOnClick },
	          _react2.default.createElement(_Avatar2.default, { alt: _config2.default.infoTitle, src: _avatar2.default, className: classes.avatar })
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: classes.title },
	          _config2.default.infoTitle,
	          _config2.default.infoTitleNote && _react2.default.createElement(
	            'small',
	            null,
	            _config2.default.infoTitleNote
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginLeft: 'auto' } },
	          _react2.default.createElement(_TopMenu2.default, { pages: pages, homeLinkOnClick: this.homeLinkOnClick, pageLinkOnClick: this.pageLinkOnClick })
	        )
	      )
	    );
	  };
	
	  return InfoBar;
	}(_react2.default.Component);
	
	InfoBar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  pages: _propTypes2.default.array.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    navigatorShape: state.navigatorShape
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(InfoBar));
	module.exports = exports['default'];

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ClickAwayListener = __webpack_require__(206);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(107);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _MenuItem = __webpack_require__(212);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuList = __webpack_require__(108);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _Paper = __webpack_require__(109);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _MoreVert = __webpack_require__(554);
	
	var _MoreVert2 = _interopRequireDefault(_MoreVert);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactPopper = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _topMenu;
	
	  return {
	    topMenu: (_topMenu = {
	      float: 'right',
	      margin: '5px 10px 0 0'
	    }, _topMenu['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {}, _topMenu),
	    open: {
	      color: theme.bars.colors.icon
	    },
	    popperClose: {
	      pointerEvents: 'none'
	    }
	  };
	};
	
	var TopMenu = function (_React$Component) {
	  _inherits(TopMenu, _React$Component);
	
	  function TopMenu() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TopMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      open: false
	    }, _this.handleClick = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _this.handleClose = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      _this.timeout = setTimeout(function () {
	        _this.setState({ open: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TopMenu.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  };
	
	  TopMenu.prototype.render = function render() {
	    var _classNames,
	        _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        pages = _props.pages;
	    var _state = this.state,
	        anchorEl = _state.anchorEl,
	        open = _state.open;
	
	
	    return _react2.default.createElement(
	      'nav',
	      { className: classes.topMenu },
	      _react2.default.createElement(
	        _reactPopper.Manager,
	        null,
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              'aria-label': 'More',
	              'aria-owns': anchorEl ? 'long-menu' : null,
	              'aria-haspopup': 'true',
	              onClick: this.handleClick,
	              className: classes.open
	            },
	            _react2.default.createElement(_MoreVert2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactPopper.Popper,
	          { placement: 'bottom-end', eventsEnabled: open, className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames)) },
	          _react2.default.createElement(
	            _ClickAwayListener2.default,
	            { onClickAway: this.handleClose },
	            _react2.default.createElement(
	              _Grow2.default,
	              { 'in': open, id: 'menu-list', style: { transformOrigin: '0 0 0' } },
	              _react2.default.createElement(
	                _Paper2.default,
	                null,
	                _react2.default.createElement(
	                  _MenuList2.default,
	                  { role: 'menu' },
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    {
	                      onClick: function onClick(e) {
	                        _this2.props.homeLinkOnClick(e);
	                        _this2.handleClose();
	                      }
	                    },
	                    'Home'
	                  ),
	                  pages.map(function (page, i) {
	                    var _page$node = page.node,
	                        fields = _page$node.fields,
	                        frontmatter = _page$node.frontmatter;
	
	
	                    return _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { key: fields.slug, to: fields.slug, style: { display: 'block' } },
	                      _react2.default.createElement(
	                        _MenuItem2.default,
	                        {
	                          onClick: function onClick(e) {
	                            _this2.props.pageLinkOnClick(e);
	                            _this2.handleClose();
	                          }
	                        },
	                        frontmatter.menuTitle ? frontmatter.menuTitle : frontmatter.title
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/contact/', style: { display: 'block' } },
	                    _react2.default.createElement(
	                      _MenuItem2.default,
	                      {
	                        onClick: function onClick(e) {
	                          _this2.props.pageLinkOnClick(e);
	                          _this2.handleClose();
	                        }
	                      },
	                      'Contact'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TopMenu;
	}(_react2.default.Component);
	
	TopMenu.propTypes = {
	  pages: _propTypes2.default.array.isRequired,
	  classes: _propTypes2.default.object.isRequired,
	  pageLinkOnClick: _propTypes2.default.func.isRequired,
	  homeLinkOnClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(TopMenu);
	module.exports = exports['default'];

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InfoBar = __webpack_require__(596);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InfoBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    wrapper: {
	      padding: '1px',
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      right: 0,
	      overflow: 'hidden',
	      '@media print': {
	        position: 'relative',
	        overflow: 'visible'
	      }
	    }
	  };
	};
	
	var LayoutWrapper = function LayoutWrapper(props) {
	  var classes = props.classes,
	      children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.wrapper },
	    children
	  );
	};
	
	LayoutWrapper.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	
	exports.default = (0, _reactJss2.default)(styles)(LayoutWrapper);
	module.exports = exports['default'];

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LayoutWrapper = __webpack_require__(605);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LayoutWrapper).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactLazyload = __webpack_require__(144);
	
	var _ListHeader = __webpack_require__(609);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _SpringScrollbars = __webpack_require__(330);
	
	var _SpringScrollbars2 = _interopRequireDefault(_SpringScrollbars);
	
	var _ListItem = __webpack_require__(610);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _inner;
	
	  return {
	    posts: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      bottom: 0,
	      width: '100%'
	    },
	    inner: (_inner = {
	      padding: 'calc(' + theme.bars.sizes.infoBar + 'px + 1.3rem) 1.3rem calc(' + theme.bars.sizes.actionsBar + 'px + 1.3rem) 1.3rem'
	    }, _inner['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {
	      padding: 'calc(' + theme.bars.sizes.infoBar + 'px + 2rem) 2rem calc(' + theme.bars.sizes.actionsBar + 'px + 2rem) 2rem'
	    }, _inner['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      padding: '2rem  calc(1rem + 17px) calc(2rem + 17px) 2rem',
	      left: theme.info.sizes.width + 'px',
	      '.moving-featured &, .is-aside &': {
	        padding: '1rem .5rem 1rem .5rem'
	      }
	    }, _inner),
	    list: {
	      listStyle: 'none',
	      margin: 0,
	      padding: 0,
	      '.is-aside.closed &, .moving-featured.closed &': {
	        display: 'none'
	      }
	    }
	  };
	};
	
	var List = function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  List.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.categoryFilter !== this.props.categoryFilter) {
	      setTimeout(_reactLazyload.forceCheck, 300);
	    }
	  };
	
	  List.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        posts = _props.posts,
	        linkOnClick = _props.linkOnClick,
	        expandOnClick = _props.expandOnClick,
	        categoryFilter = _props.categoryFilter,
	        navigatorShape = _props.navigatorShape,
	        removeFilter = _props.removeFilter;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: classes.posts },
	      _react2.default.createElement(
	        _SpringScrollbars2.default,
	        { forceCheckOnScroll: true, isNavigator: true },
	        _react2.default.createElement(
	          'div',
	          { className: classes.inner },
	          _react2.default.createElement(_ListHeader2.default, {
	            expandOnClick: expandOnClick,
	            categoryFilter: categoryFilter,
	            navigatorShape: navigatorShape,
	            removeFilter: removeFilter
	          }),
	          _react2.default.createElement(
	            'ul',
	            { className: classes.list },
	            posts && posts.map(function (post, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, post: post, linkOnClick: linkOnClick, categoryFilter: categoryFilter });
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return List;
	}(_react2.default.Component);
	
	List.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  posts: _propTypes2.default.array.isRequired,
	  linkOnClick: _propTypes2.default.func.isRequired,
	  expandOnClick: _propTypes2.default.func.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired,
	  removeFilter: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(List);
	module.exports = exports['default'];

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Close = __webpack_require__(546);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _ExpandLess = __webpack_require__(547);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _filter;
	
	  return {
	    closed: {
	      display: 'none',
	      '.is-aside.closed &, .moving-featured.closed &': {
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'space-between',
	        alignItems: 'center',
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        width: '100%',
	        margin: 0,
	        height: theme.navigator.sizes.closedHeight + 'px',
	        padding: '0 30px 0 40px'
	      },
	      '& h3': {
	        fontSize: '1.1em',
	        color: theme.navigator.colors.postsHeader,
	        fontWeight: 600,
	        margin: '-.2em 0 0 0',
	        textTransform: 'uppercase',
	        '& small': {
	          fontSize: '.6em',
	          display: 'block',
	          margin: '0 0 .1em',
	          fontWeight: 300,
	          letterSpacing: '.2em'
	        }
	      }
	    },
	    expand: {
	      color: theme.navigator.colors.postsHeader
	    },
	    filter: (_filter = {
	      margin: '0 calc(-.5rem + ' + theme.base.sizes.linesMargin + ') 1em calc(-.5rem + ' + theme.base.sizes.linesMargin + ')',
	      position: 'relative',
	      fontSize: '1.2em',
	      lineHeight: 1,
	      color: theme.base.colors.accent,
	      borderBottom: '1px solid ' + theme.base.colors.lines,
	      padding: '0 1em 1em',
	      fontWeight: 300,
	      '& strong': {
	        fontWeight: 600,
	        display: 'block'
	      },
	      '& small': {
	        display: 'block',
	        margin: '0 0 .3em 0'
	      }
	    }, _filter['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      margin: '0 0 1em 0',
	      padding: '0 1em 1.5em',
	      '.is-aside &': {
	        padding: '0 0 1em .5em',
	        margin: '0 calc(-.5rem + ' + theme.base.sizes.linesMargin + ') 1em calc(-.5rem + ' + theme.base.sizes.linesMargin + ')'
	      }
	    }, _filter),
	    clear: {
	      position: 'absolute',
	      top: 0,
	      right: 0
	    }
	  };
	};
	
	var ListHeader = function ListHeader(props) {
	  var classes = props.classes,
	      expandOnClick = props.expandOnClick,
	      categoryFilter = props.categoryFilter,
	      navigatorShape = props.navigatorShape,
	      removeFilter = props.removeFilter;
	
	
	  return _react2.default.createElement(
	    'header',
	    null,
	    navigatorShape === 'closed' && _react2.default.createElement(
	      'div',
	      { className: classes.closed },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'List of posts'
	      ),
	      _react2.default.createElement(
	        _IconButton2.default,
	        {
	          'aria-label': 'Expand the list',
	          className: classes.expand,
	          onClick: expandOnClick,
	          title: 'Expand the list'
	        },
	        _react2.default.createElement(_ExpandLess2.default, null)
	      )
	    ),
	    navigatorShape === 'open' && categoryFilter !== 'all posts' && _react2.default.createElement(
	      'div',
	      { className: classes.filter },
	      _react2.default.createElement(
	        'small',
	        null,
	        'Active category filter:'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        categoryFilter
	      ),
	      _react2.default.createElement(
	        _IconButton2.default,
	        {
	          'aria-label': 'Remove filtering',
	          className: classes.clear,
	          onClick: removeFilter,
	          title: 'Clear filtering'
	        },
	        _react2.default.createElement(_Close2.default, null)
	      )
	    )
	  );
	};
	
	ListHeader.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  expandOnClick: _propTypes2.default.func.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  removeFilter: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ListHeader);
	module.exports = exports['default'];

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactLazyload = __webpack_require__(144);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _listItem, _listItemPointer, _h, _h2, _listItemText;
	
	  return {
	    listItem: (_listItem = {
	      margin: '0 0 .7em 0',
	      transition: 'height 1s'
	    }, _listItem['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {
	      margin: '0 0 1.5rem 0'
	    }, _listItem['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      '.moving-featured &, .is-aside &': {
	        margin: '0 0 0 0'
	      }
	    }, _listItem),
	    listLink: {
	      display: 'flex',
	      alignContent: 'center',
	      alignItems: 'center',
	      justifyContent: 'flex-start',
	      flexDirection: 'row',
	      padding: '.7em 1em .7em 1em',
	      color: theme.navigator.colors.postsListItemLink,
	      '@media (hover: hover)': {
	        '&:hover': {
	          color: theme.navigator.colors.postsListItemLinkHover,
	          '& .pointer': {
	            borderRadius: '65% 75%'
	          }
	        }
	      }
	    },
	    listItemPointer: (_listItemPointer = {
	      position: 'relative',
	      flexShrink: 0,
	      overflow: 'hidden',
	      borderRadius: '75% 65%',
	      width: '60px',
	      height: '60px',
	      margin: '0',
	      transition: 'all .5s',
	      '& img': {
	        width: '100%',
	        height: '100%'
	      }
	    }, _listItemPointer['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {
	      marginRight: '.5em',
	      width: '80px',
	      height: '80px'
	    }, _listItemPointer['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      marginRight: '.8em',
	      width: '90px',
	      height: '90px',
	      transition: 'all .3s',
	      transitionTimingFunction: 'ease',
	      '.moving-featured &, .is-aside &': {
	        width: '30px',
	        height: '30px'
	      }
	    }, _listItemPointer),
	    listItemText: (_listItemText = {
	      font: 'Cereal-Book',
	      margin: '0 0 0 1.5em',
	      flexGrow: 1,
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      '& h1': (_h = {
	        lineHeight: 1.15,
	        fontWeight: 600,
	        letterSpacing: '-0.03em',
	        margin: 0,
	        fontSize: theme.navigator.sizes.postsListItemH1Font + 'em'
	      }, _h['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {
	        fontSize: theme.navigator.sizes.postsListItemH1Font * theme.navigator.sizes.fontIncraseForM + 'em'
	      }, _h['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	        fontSize: theme.navigator.sizes.postsListItemH1Font * theme.navigator.sizes.fontIncraseForL + 'em',
	        '.moving-featured &, .is-aside &': {
	          fontSize: '1em',
	          fontWeight: 400
	        }
	      }, _h),
	      '& h2': (_h2 = {
	        lineHeight: 1.2,
	        display: 'block',
	        fontSize: theme.navigator.sizes.postsListItemH2Font + 'em',
	        margin: '.3em 0 0 0'
	      }, _h2['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {
	        fontSize: theme.navigator.sizes.postsListItemH2Font * theme.navigator.sizes.fontIncraseForM + 'em'
	      }, _h2['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	        fontSize: theme.navigator.sizes.postsListItemH2Font * theme.navigator.sizes.fontIncraseForL + 'em',
	        '.moving-featured &, .is-aside &': {
	          display: 'none'
	        }
	      }, _h2)
	    }, _listItemText['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      '.moving-featured &, .is-aside &': {
	        margin: '0 0 0 .5em'
	      }
	    }, _listItemText)
	  };
	};
	
	var ListItem = function (_React$Component) {
	  _inherits(ListItem, _React$Component);
	
	  function ListItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      hidden: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ListItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.categoryFilter !== this.props.categoryFilter) {
	      var category = this.props.post.node.frontmatter.category;
	      var categoryFilter = this.props.categoryFilter;
	
	      if (categoryFilter === 'all posts') {
	        this.setState({ hidden: false });
	      } else if (category !== categoryFilter) {
	        this.setState({ hidden: true });
	      } else if (category === categoryFilter) {
	        this.setState({ hidden: false });
	      }
	    }
	  };
	
	  ListItem.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        post = _props.post,
	        linkOnClick = _props.linkOnClick;
	
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: classes.listItem + ' ' + post.node.frontmatter.category,
	        style: { display: '' + (this.state.hidden ? 'none' : 'block') },
	        key: post.node.fields.slug
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { activeClassName: 'active', className: classes.listLink, to: post.node.fields.slug, onClick: linkOnClick },
	        post.node.frontmatter.cover && post.node.frontmatter.cover.children[0] && _react2.default.createElement(
	          'div',
	          { className: classes.listItemPointer + ' pointer' },
	          _react2.default.createElement(
	            _reactLazyload2.default,
	            { height: 60, overflow: true, throttle: 300, once: true, offset: 100 },
	            _react2.default.createElement(
	              'picture',
	              null,
	              _react2.default.createElement('source', { type: 'image/webp', srcSet: post.node.frontmatter.cover.children[0].resolutions.srcSetWebp }),
	              _react2.default.createElement('source', { srcSet: post.node.frontmatter.cover.children[0].resolutions.srcSet }),
	              _react2.default.createElement('img', { src: post.node.frontmatter.cover.children[0].resolutions.src, alt: '' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.listItemText },
	          _react2.default.createElement(
	            'h1',
	            null,
	            post.node.frontmatter.title
	          ),
	          post.node.frontmatter.subTitle && _react2.default.createElement(
	            'h2',
	            null,
	            post.node.frontmatter.subTitle
	          )
	        )
	      )
	    );
	  };
	
	  return ListItem;
	}(_react2.default.Component);
	
	ListItem.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  post: _propTypes2.default.object.isRequired,
	  linkOnClick: _propTypes2.default.func.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ListItem);
	module.exports = exports['default'];

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(48);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactLazyload = __webpack_require__(144);
	
	var _store = __webpack_require__(45);
	
	var _shared = __webpack_require__(74);
	
	var _List = __webpack_require__(608);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _navigator;
	
	  return {
	    navigator: (_navigator = {
	      transform: 'translate3d(0, 0, 0)',
	      willChange: 'left, top, bottom, width',
	      background: theme.navigator.colors.background,
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      height: '100vh',
	      transitionTimingFunction: 'ease',
	      transition: 'left .9s',
	      width: '100%'
	    }, _navigator['@media (max-width: ' + (theme.mediaQueryTresholds.L - 1) + 'px)'] = {
	      '&.is-aside': {
	        left: '-100%'
	      },
	      '&.is-featured': {
	        left: 0
	      }
	    }, _navigator['@media (min-width: ' + theme.mediaQueryTresholds.L + 'px)'] = {
	      '&.is-featured': {
	        transition: 'left .9s',
	        width: 'calc(100vw - ' + theme.info.sizes.width + 'px - ' + theme.bars.sizes.actionsBar + 'px)',
	        left: theme.info.sizes.width + 'px',
	        top: 0
	      },
	      '&.is-aside': {
	        transition: 'none, bottom 0.5s',
	        left: 0,
	        width: theme.info.sizes.width - 1 + 'px',
	        zIndex: 1,
	        top: 'auto',
	        '&.closed': {
	          bottom: 'calc(-100% + 100px + ' + theme.navigator.sizes.closedHeight + 'px)',
	          height: 'calc(100% - 100px)'
	        },
	        '&.open': {
	          bottom: 0,
	          height: 'calc(100% - 100px)'
	        },
	        '&::after': {
	          content: '""',
	          position: 'absolute',
	          top: 0,
	          left: theme.base.sizes.linesMargin,
	          right: theme.base.sizes.linesMargin,
	          height: 0,
	          borderTop: '1px solid ' + theme.base.colors.lines
	        }
	      },
	      '&.moving-aside': {
	        transition: 'left 0.9s',
	        left: 'calc(-100vw + ' + (2 * theme.info.sizes.width + 60) + 'px)',
	        width: 'calc(100vw - ' + theme.info.sizes.width + 'px - 60px)',
	        top: 0
	      },
	      '&.resizing-aside': {
	        transition: 'none',
	        width: theme.info.sizes.width - 1 + 'px',
	        top: 'auto',
	        left: 0,
	        '&.closed': {
	          bottom: 'calc(-100% + 100px)',
	          height: 'calc(100% - 100px)'
	        },
	        '&.open': {
	          bottom: 'calc(-100% + 100px)',
	          height: 'calc(100% - 100px)'
	        }
	      },
	      '&.moving-featured': {
	        transition: 'bottom .3s',
	
	        bottom: '-100%',
	        top: 'auto',
	        left: 0,
	        zIndex: 1,
	        width: theme.info.sizes.width - 1 + 'px'
	      },
	      '&.resizing-featured': {
	        transition: 'none',
	        top: 0,
	        bottom: 'auto',
	        left: 'calc(-100vw + ' + (2 * theme.info.sizes.width + 60) + 'px)',
	        width: 'calc(100vw - ' + theme.info.sizes.width + 'px - 60px)'
	      }
	    }, _navigator)
	  };
	};
	
	var Navigator = function (_React$Component) {
	  _inherits(Navigator, _React$Component);
	
	  function Navigator() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.linkOnClick = _shared.moveNavigatorAside.bind(_this), _this.expandOnClick = function (e) {
	      _this.props.setNavigatorShape('open');
	      setTimeout(_reactLazyload.forceCheck, 600);
	    }, _this.removefilterOnClick = function (e) {
	      _this.props.setCategoryFilter('all posts');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Navigator.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        posts = _props.posts,
	        navigatorPosition = _props.navigatorPosition,
	        navigatorShape = _props.navigatorShape,
	        categoryFilter = _props.categoryFilter;
	
	
	    return _react2.default.createElement(
	      'nav',
	      {
	        className: classes.navigator + ' ' + (navigatorPosition ? navigatorPosition : '') + ' ' + (navigatorShape ? navigatorShape : '') + ' '
	      },
	      this.props.posts.length && _react2.default.createElement(_List2.default, {
	        posts: posts,
	        navigatorPosition: navigatorPosition,
	        navigatorShape: navigatorShape,
	        linkOnClick: this.linkOnClick,
	        expandOnClick: this.expandOnClick,
	        categoryFilter: categoryFilter,
	        removeFilter: this.removefilterOnClick
	      })
	    );
	  };
	
	  return Navigator;
	}(_react2.default.Component);
	
	Navigator.propTypes = {
	  posts: _propTypes2.default.array.isRequired,
	  classes: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  setNavigatorShape: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired,
	  setCategoryFilter: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    navigatorShape: state.navigatorShape,
	    isWideScreen: state.isWideScreen,
	    categoryFilter: state.categoryFilter
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape,
	  setCategoryFilter: _store.setCategoryFilter
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(Navigator));
	module.exports = exports['default'];

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Navigator = __webpack_require__(611);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Navigator).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = asyncComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function asyncComponent(getComponent, loadingComponent) {
	  var AsyncComponent = function (_React$Component) {
	    _inherits(AsyncComponent, _React$Component);
	
	    function AsyncComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AsyncComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { Component: null }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    AsyncComponent.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.state.Component) {
	        getComponent().then(function (Component) {
	          _this2.setState({ Component: Component });
	        });
	      }
	    };
	
	    AsyncComponent.prototype.render = function render() {
	      var Component = this.state.Component;
	
	      if (Component) {
	        return _react2.default.createElement(Component, this.props);
	      }
	      return loadingComponent ? loadingComponent : _react2.default.createElement(
	        'div',
	        null,
	        'Loading...'
	      );
	    };
	
	    return AsyncComponent;
	  }(_react2.default.Component);
	
	  return AsyncComponent;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncComponent = __webpack_require__(223);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AsyncComponent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _CircularProgress = __webpack_require__(493);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    loading: {
	      display: 'flex',
	      background: function background(props) {
	        return props.overrides && props.overrides.background ? props.overrides.background : theme.base.colors.background;
	      },
	      position: 'absolute',
	      left: function left(props) {
	        return props.overrides && props.overrides.left ? props.overrides.left : 0;
	      },
	      right: function right(props) {
	        return props.overrides && props.overrides.right ? props.overrides.right : 0;
	      },
	      top: '0',
	      width: function width(props) {
	        return props.overrides && props.overrides.width ? props.overrides.width : '100%';
	      },
	      height: function height(props) {
	        return props.overrides && props.overrides.height ? props.overrides.height : '100%';
	      },
	      flexDirection: 'column',
	      justifyContent: 'center',
	      alignItems: 'center',
	      '&::after': {
	        content: function content(props) {
	          return props.afterLeft || props.afterRight ? '""' : '';
	        },
	        position: 'absolute',
	        right: function right(props) {
	          return props.afterRight ? 0 : '';
	        },
	        left: function left(props) {
	          return props.afterLeft ? 0 : '';
	        },
	        top: theme.base.sizes.linesMargin,
	        bottom: theme.base.sizes.linesMargin,
	        width: 0,
	        borderRight: '1px solid ' + theme.base.colors.lines
	      }
	    },
	    progress: {}
	  };
	};
	
	var Loading = function Loading(props) {
	  var classes = props.classes,
	      progressSize = props.progressSize;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.loading },
	    _react2.default.createElement(_CircularProgress2.default, { className: classes.progress, size: progressSize ? progressSize : 30 })
	  );
	};
	
	Loading.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  progressSize: _propTypes2.default.number,
	  overrides: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Loading);
	module.exports = exports['default'];

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Loading = __webpack_require__(627);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Loading).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {'use strict';
	
	exports.__esModule = true;
	exports.default = getPageContext;
	
	var _jss = __webpack_require__(170);
	
	var _styles = __webpack_require__(110);
	
	var _theme = __webpack_require__(332);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPageContext() {
	  return {
	    theme: _theme2.default,
	    // This is needed in order to deduplicate the injection of CSS in the page.
	    sheetsManager: new Map(),
	    // This is needed in order to inject the critical CSS.
	    sheetsRegistry: new _jss.SheetsRegistry(),
	    // The standard class name generator.
	    generateClassName: (0, _styles.createGenerateClassName)()
	  };
	} /* eslint-disable no-underscore-dangle */
	
	function getPageContext() {
	  // Make sure to create a new context for every server-side request so that data
	  // isn't shared between connections (which would be bad).
	  if (!process.browser) {
	    return createPageContext();
	  }
	
	  // Reuse context on the client-side.
	  if (!global.__INIT_MATERIAL_UI__) {
	    global.__INIT_MATERIAL_UI__ = createPageContext();
	  }
	
	  return global.__INIT_MATERIAL_UI__;
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71), (function() { return this; }())))

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avatar.ff61368c.jpg";

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.guery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(48);
	
	var _withRoot = __webpack_require__(639);
	
	var _withRoot2 = _interopRequireDefault(_withRoot);
	
	var _newTheme = __webpack_require__(331);
	
	var _newTheme2 = _interopRequireDefault(_newTheme);
	
	var _globals = __webpack_require__(634);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _store = __webpack_require__(45);
	
	var _AsyncComponent = __webpack_require__(224);
	
	var _AsyncComponent2 = _interopRequireDefault(_AsyncComponent);
	
	var _Loading = __webpack_require__(628);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Navigator = __webpack_require__(612);
	
	var _Navigator2 = _interopRequireDefault(_Navigator);
	
	var _ActionsBar = __webpack_require__(591);
	
	var _ActionsBar2 = _interopRequireDefault(_ActionsBar);
	
	var _InfoBar = __webpack_require__(598);
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _LayoutWrapper = __webpack_require__(606);
	
	var _LayoutWrapper2 = _interopRequireDefault(_LayoutWrapper);
	
	var _helpers = __webpack_require__(638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBox = (0, _AsyncComponent2.default)(function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      resolve(__webpack_require__(604));
	    });
	  }).then(function (module) {
	    return module;
	  }).catch(function (error) {});
	}, _react2.default.createElement(_Loading2.default, { overrides: { width: _newTheme2.default.info.sizes.width + 'px', height: '100vh', right: 'auto' }, afterRight: true }));
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.timeouts = {}, _this.categories = [], _this.getCategories = function () {
	      var _this$props$data$post = _this.props.data.posts.edges,
	          edges = _this$props$data$post === undefined ? undefined : _this$props$data$post;
	
	      if (!edges) {
	        return;
	      }
	      _this.categories = edges.reduce(function (list, edge, i) {
	        var category = edge.node.frontmatter.category;
	        if (category && !~list.indexOf(category)) {
	          return list.concat(edge.node.frontmatter.category);
	        } else {
	          return list;
	        }
	      }, []);
	    }, _this.resizeThrottler = function () {
	      return (0, _helpers.timeoutThrottlerHandler)(_this.timeouts, 'resize', 500, _this.resizeHandler);
	    }, _this.resizeHandler = function () {
	      _this.props.setIsWideScreen((0, _helpers.isWideScreen)());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    this.props.setIsWideScreen((0, _helpers.isWideScreen)());
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.resizeThrottler, false);
	    }
	  };
	
	  Layout.prototype.componentWillMount = function componentWillMount() {
	    if (typeof localStorage !== 'undefined') {
	      var inLocal = +localStorage.getItem('font-size-increase');
	
	      var inStore = this.props.fontSizeIncrease;
	
	      if (inLocal && inLocal !== inStore && inLocal >= 1 && inLocal <= 1.5) {
	        this.props.setFontSizeIncrease(inLocal);
	      }
	    }
	
	    this.getCategories();
	  };
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data;
	
	    console.log(this.props, data);
	    // TODO: dynamic management of tabindexes for keybord navigation
	    return _react2.default.createElement(
	      _LayoutWrapper2.default,
	      null,
	      children(),
	      _react2.default.createElement(_Navigator2.default, { posts: data.posts.edges }),
	      _react2.default.createElement(_ActionsBar2.default, { categories: this.categories }),
	      _react2.default.createElement(_InfoBar2.default, { pages: data.pages.edges, parts: data.parts.edges }),
	      this.props.isWideScreen && _react2.default.createElement(InfoBox, { pages: data.pages.edges, parts: data.parts.edges })
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.func.isRequired,
	  setIsWideScreen: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired,
	  fontSizeIncrease: _propTypes2.default.number.isRequired,
	  setFontSizeIncrease: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    pages: state.pages,
	    isWideScreen: state.isWideScreen,
	    fontSizeIncrease: state.fontSizeIncrease
	  };
	};
	
	var mapDispatchToProps = {
	  setIsWideScreen: _store.setIsWideScreen,
	  setFontSizeIncrease: _store.setFontSizeIncrease
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withRoot2.default)((0, _reactJss2.default)(_globals2.default)(Layout)));
	
	//eslint-disable-next-line no-undef
	
	var guery = exports.guery = '** extracted graphql fragment **';

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _newTheme = __webpack_require__(331);
	
	var _newTheme2 = _interopRequireDefault(_newTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  /*
	      BEGINNING OF NORMALIZE STYLE
	    */
	
	  '@global': {
	    /**
	     * Add the correct display in IE9
	     */
	    'article, aside, footer, header, nav, section, figcaption, figure, main': {
	      display: 'block'
	    },
	
	    /**
	     * Correct the font size and margin on `h1` elements within `section` and
	     * `article` contexts in Chrome, Firefox, and Safari.
	     */
	    h1: {
	      fontSize: '2em',
	      margin: [['0.67em', 0]]
	    },
	
	    /**
	     * 1. Add the correct box sizing in Firefox.
	     * 2. Show the overflow in Edge and IE.
	     */
	    hr: {
	      boxSizing: 'content-box' /* 1 */
	      , height: 0 /* 1 */
	      , overflow: 'visible' /* 2 */
	    },
	
	    /**
	     * 1. Correct the inheritance and scaling of font size in all browsers.
	     * 2. Correct the odd `em` font sizing in all browsers.
	     */
	    pre: {
	      fontFamily: 'monospace, monospace' /* 1 */
	      , fontSize: '1em' /* 2 */
	    },
	
	    /**
	     * 1. Remove the gray background on active links in IE 10.
	     * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
	     * 3. Remove the outline on focused links when they are also
	     *    active or hovered in all browsers (opinionated).
	     */
	    // a: {
	    //   background: "transparent" /* 1 */,
	    //   textDecorationSkip: "objects" /* 2 */
	    // },
	    'a:active, a:hover': {
	      outlineWidth: 0 /* 3 */
	    },
	
	    /**
	     * 1. Remove the bottom border in Firefox 39-.
	     * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
	     */
	    'abbr[title]': {
	      borderBottom: 'none' /* 1 */
	      , textDecoration: 'underline' /* 2 */
	    },
	
	    /**
	     * Add the correct font weight in Chrome, Edge, and Safari.
	     */
	    'b, strong': {
	      fontWeight: 'bolder'
	    },
	
	    /**
	     * 1. Correct the inheritance and scaling of font size in all browsers.
	     * 2. Correct the odd `em` font sizing in all browsers.
	     */
	    'code, kbp, samp': {
	      fontFamily: 'monospace, monospace' /* 1 */
	      , fontSize: '1em' /* 2 */
	    },
	
	    /**
	     * Add the correct font style in Android 4.3-.
	     */
	    dfn: {
	      fontStyle: 'italic'
	    },
	
	    /**
	     * Add the correct background and color in IE 9-.
	     */
	    mark: {
	      backgroundColor: '#ff0',
	      color: '#000'
	    },
	
	    /**
	     * Add the correct font size in all browsers.
	     */
	    small: {
	      fontSize: '80%'
	    },
	
	    /**
	     * Prevent `sub` and `sup` elements from affecting the line height in
	     * all browsers.
	     */
	    'sub, sup': {
	      fontSize: '75%',
	      lineHeight: 0,
	      position: 'relative',
	      verticalAlign: 'baseline'
	    },
	    sup: {
	      top: '-0.5em'
	    },
	    sub: {
	      bottom: '-0.25em'
	    },
	
	    /**
	     * Add the correct display in IE 9-.
	     */
	    'audio, video': {
	      display: 'inline-block'
	    },
	
	    /**
	     * Add the correct display in iOS 4-7.
	     */
	    'audio:not([controls])': {
	      display: 'none',
	      height: 0
	    },
	
	    /**
	     * 1. Remove the border on images inside links in IE 10-.
	     * 2. Remove extra space in all browsers
	     */
	    img: {
	      borderStyle: 'none' /* 1 */
	      , verticalAlign: 'middle' /* 2 */
	    },
	
	    /**
	     * Hide the overflow in IE.
	     */
	    'svg:not(:root)': {
	      overflow: 'hidden'
	    },
	
	    /**
	     * 1. Change the font styles in all browsers (opinionated).
	     * 2. Remove the margin in Firefox and Safari.
	     */
	    'button, input, optgroup, select, textarea': {
	      fontFamily: 'sans-serif' /* 1 */
	      , fontSize: '100%' /* 1 */
	      , lineHeight: '1.15' /* 1 */
	      , margin: 0 /* 2 */
	    },
	
	    /**
	     * Show the overflow in IE & Edge.
	     */
	    'button, input': {
	      overflow: 'visible'
	    },
	
	    /**
	     * Remove the inheritance of text transform in Edge, Firefox, and IE.
	     */
	    'button, select': {
	      textTransform: 'none'
	    },
	
	    /**
	     * Correct the inability to style clickable types in iOS and Safari.
	     */
	    'button, [type=reset], [type=submit]': {
	      '-webkit-appearance': 'button'
	    },
	
	    /**
	     * Remove the inner border and padding in Firefox.
	     */
	    'button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner': {
	      borderStyle: 'none',
	      padding: 0
	    },
	
	    /**
	     * Restore the focus styles unset by the previous rule.
	     */
	    'button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring': {
	      outline: '1px dotted ButtonText'
	    },
	
	    /**
	     * Change the border, margin, and padding in all browsers (opinionated).
	     */
	    fieldset: {
	      border: '1px solid #c0c0c0',
	      margin: [[0, '2px']],
	      padding: [['0.35em', '0.625em', '0.75em']]
	    },
	
	    /**
	     * 1. Correct the text wrapping in Edge and IE.
	     * 2. Correct the color inheritance from `fieldset` elements in IE.
	     * 3. Remove the padding so developers are not caught out when they zero out
	     *    `fieldset` elements in all browsers.
	     */
	    legend: {
	      boxSizing: 'border-box' /* 1 */
	      , color: 'inherit' /* 2 */
	      , display: 'table' /* 1 */
	      , maxWidth: '100%' /* 1 */
	      , padding: 0 /* 3 */
	      , whiteSpace: 'normal' /* 1 */
	    },
	
	    /**
	     * 1. Add the correct display in IE 9-.
	     * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
	     */
	    progress: {
	      display: 'inline-block' /* 1 */
	      , verticalAlign: 'baseline' /* 2 */
	    },
	
	    /**
	     * Remove the default vertical scrollbar in IE.
	     */
	    textarea: {
	      overflow: 'auto'
	    },
	
	    /**
	     * 1. Add the correct box sizing in IE 10-.
	     * 2. Remove the padding in IE 10-.
	     */
	    '[type=checkbox], [type=radio]': {
	      boxSizing: 'border-box' /* 1 */
	      , padding: 0 /* 2 */
	    },
	
	    /**
	     * Correct the cursor style of increment and decrement buttons in Chrome.
	     */
	    '[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button': {
	      height: 'auto'
	    },
	
	    /**
	     * 1. Correct the odd appearance in Chrome and Safari.
	     * 2. Correct the outline style in Safari.
	     */
	    '[type=search]': {
	      appearance: 'textfield' /* 1 */
	      , outlineOffset: '-2px' /* 2 */
	    },
	
	    /**
	     * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.
	     */
	    '[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration': {
	      appearance: 'none'
	    },
	
	    /**
	     * 1. Correct the inability to style clickable types in iOS and Safari.
	     * 2. Change font properties to `inherit` in Safari.
	     */
	    '::-webkit-file-upload-button': {
	      appearance: 'button' /* 1 */
	      , font: 'inherit' /* 2 */
	    },
	
	    /*
	     * Add the correct display in Edge, IE, and Firefox.
	     */
	    'details, menu': {
	      display: 'block'
	    },
	
	    /*
	     * Add the correct display in all browsers.
	     */
	    summary: {
	      display: 'list-item'
	    },
	
	    /**
	     * Add the correct display in IE 9-.
	     */
	    canvas: {
	      display: 'inline-block'
	    },
	
	    /**
	     * Add the correct display in IE.
	     */
	    template: {
	      display: 'none'
	    },
	
	    /**
	     * Add the correct display in IE 10-.
	     */
	    '[hidden]': {
	      display: 'none'
	    },
	
	    /*
	      END OF NORMALIZE STYLE
	    */
	
	    /*
	      BEGiNNIG OF CUTSOM GLOBAL STYLE
	     */
	
	    html: {
	      boxSizing: 'border-box',
	      '-webkit-text-size-adjust': '100%',
	      '-moz-text-size-adjust': 'none',
	      '-ms-text-size-adjust': '100%',
	      fontFamily: _newTheme2.default.base.fonts.unstyledFamily,
	      lineHeight: '1.15',
	      textSizeAdjust: '100%'
	    },
	    'html.wf-active': {
	      fontFamily: _newTheme2.default.base.fonts.styledFamily
	    },
	    '*, *:before, *:after': {
	      boxSizing: 'inherit'
	    },
	    noscript: {
	      background: '#d00',
	      color: '#fff',
	      position: 'absolute',
	      top: '50%',
	      left: '50%',
	      zIndex: 1000,
	      transform: 'translate(-50%, -50%)',
	      padding: '1.5rem 2.5rem',
	      fontWeight: 400,
	      borderRadius: '2px',
	      boxShadow: '0 0 10px 52px rgba(255,255,255,.8)'
	    },
	    body: {
	      margin: 0,
	      background: _newTheme2.default.base.colors.background,
	      //overflow: "hidden",
	      '-webkit-tap-highlight-color': 'rgba(0,0,0,.05)'
	    },
	    wrapper: {},
	    main: {
	      position: 'relative'
	    },
	    'h1, h2, h3': {
	      fontWeight: 300
	    },
	    a: {
	      background: 'transparent',
	      textDecorationSkip: 'objects',
	      fontWeight: 'bold',
	      textDecoration: 'none',
	      transition: '0.3s'
	    },
	    'input:-webkit-autofill': {
	      '-webkit-box-shadow': '0 0 0 50px white inset'
	    },
	    ":not(pre) > code[class*='language-']": {
	      background: '#eee',
	      color: '#666',
	      textShadow: 'none',
	      padding: '1px 5px',
	      borderRadius: '2px'
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  background: '#222222',
	  white: '#ffffff',
	  accent: '#f8aa94',
	  bright: '#cccccc',
	  dark: '#333333',
	  gray: '#555555',
	  lightGray: '#bbbbbb',
	  superLightGray: '#dedede'
	};

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styles = __webpack_require__(110);
	
	var _color = __webpack_require__(340);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _newColors = __webpack_require__(635);
	
	var _newColors2 = _interopRequireDefault(_newColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = (0, _styles.createMuiTheme)({
	  base: {
	    colors: {
	      background: _newColors2.default.background,
	      text: _newColors2.default.bright,
	      link: _newColors2.default.accent,
	      linkHover: (0, _color2.default)(_newColors2.default.accent).lighten(0.1).string(),
	      accent: _newColors2.default.accent,
	      lines: _newColors2.default.gray
	    },
	    sizes: {
	      linesMargin: '20px'
	    },
	    fonts: {
	      unstyledFamily: 'Cereal-Book',
	      styledFamily: 'Cereal-Book'
	    }
	  },
	  info: {
	    colors: {
	      text: _newColors2.default.bright,
	      background: _newColors2.default.background,
	      socialIcons: _newColors2.default.lightGray,
	      socialIconsHover: _newColors2.default.accent,
	      menuLink: _newColors2.default.bright,
	      menuLinkHover: _newColors2.default.accent
	    },
	    sizes: {
	      width: 320,
	      headerHeight: 170
	    },
	    fonts: {
	      boxTitleSize: 1.3,
	      boxTitleSizeM: 1.5,
	      boxTitleSizeL: 1.7
	    }
	  },
	  navigator: {
	    colors: {
	      background: _newColors2.default.background,
	      postsListItemLink: _newColors2.default.bright,
	      postsListItemLinkHover: _newColors2.default.accent,
	      postsHeader: _newColors2.default.bright
	    },
	    sizes: {
	      closedHeight: 80,
	      postsListItemH1Font: 1.3,
	      postsListItemH2Font: 1.1,
	      fontIncraseForM: 1.15,
	      fontIncraseForL: 1.3
	    }
	  },
	  main: {
	    colors: {
	      background: _newColors2.default.background,
	      title: _newColors2.default.bright,
	      subTitle: _newColors2.default.bright,
	      meta: _newColors2.default.bright,
	      content: _newColors2.default.bright,
	      footer: _newColors2.default.bright,
	      contentHeading: _newColors2.default.bright,
	      blockquoteFrame: _newColors2.default.dark,
	      link: _newColors2.default.accent,
	      linkHover: _newColors2.default.dark,
	      fbCommentsColorscheme: 'dark'
	    },
	    sizes: {
	      articleMaxWidth: '50em'
	    },
	    fonts: {
	      title: {
	        size: 1.9,
	        sizeM: 2.5,
	        sizeL: 2.7,
	        weight: 600,
	        lineHeight: 1.1
	      },
	      subTitle: {
	        size: 1.5,
	        sizeM: 1.8,
	        sizeL: 1.95,
	        weight: 300,
	        lineHeight: 1.1
	      },
	      meta: {
	        size: 0.9,
	        weight: 600
	      },
	      content: {
	        size: 1.0,
	        sizeM: 1.15,
	        sizeL: 1.1,
	        lineHeight: 1.6
	      },
	      contentHeading: {
	        h2Size: 1.5,
	        h3Size: 1.3,
	        weight: 600,
	        lineHeight: 1.3
	      },
	      footer: {
	        size: 1,
	        lineHeight: 1.4
	      }
	    }
	  },
	  footer: {
	    colors: {
	      text: (0, _color2.default)(_newColors2.default.gray).lighten(0.5).string(),
	      link: _newColors2.default.accent,
	      linkHover: (0, _color2.default)(_newColors2.default.accent).lighten(0.2).string()
	    },
	    fonts: {
	      footnote: {
	        size: 0.8,
	        lineHeight: 1.4
	      }
	    }
	  },
	  bars: {
	    colors: {
	      background: _newColors2.default.background,
	      icon: _newColors2.default.bright,
	      text: _newColors2.default.bright
	    },
	    sizes: {
	      actionsBar: 60,
	      infoBar: 60
	    }
	  },
	  mediaQueryTresholds: {
	    M: 600,
	    L: 1024
	  },
	  palette: {
	    primary: {
	      main: '#f8aa94'
	    },
	    type: 'dark',
	    action: {
	      hover: 'rgba(0, 0, 0, 0.01)'
	    }
	  },
	  typography: {
	    font: 'Cereal-Book',
	    fontSize: 16
	  }
	}); // This is a custom theme, for details go to http://forgatsby.greglobinski.com/customize-personal-blog-starter/
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styles = __webpack_require__(110);
	
	var _color = __webpack_require__(340);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _colors = __webpack_require__(158);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = (0, _styles.createMuiTheme)({
	  overrides: {
	    MuiMenuItem: {
	      root: {
	        font: 'Cereal-Book'
	      }
	    }
	  },
	  base: {
	    colors: {
	      background: _colors2.default.background,
	      text: _colors2.default.dark,
	      link: _colors2.default.accent,
	      linkHover: (0, _color2.default)(_colors2.default.accent).lighten(0.1).string(),
	      accent: _colors2.default.accent,
	      lines: _colors2.default.superLightGray
	    },
	    sizes: {
	      linesMargin: '20px'
	    },
	    fonts: {
	      unstyledFamily: 'Cereal-Book'
	    }
	  },
	  info: {
	    colors: {
	      text: _colors2.default.gray,
	      background: _colors2.default.background,
	      socialIcons: _colors2.default.lightGray,
	      socialIconsHover: _colors2.default.accent,
	      menuLink: _colors2.default.gray,
	      menuLinkHover: _colors2.default.accent
	    },
	    sizes: {
	      width: 320,
	      headerHeight: 170
	    },
	    fonts: {
	      boxTitleSize: 1.3,
	      boxTitleSizeM: 1.5,
	      boxTitleSizeL: 1.7
	    }
	  },
	  navigator: {
	    colors: {
	      background: _colors2.default.background,
	      postsListItemLink: _colors2.default.gray,
	      postsListItemLinkHover: _colors2.default.accent,
	      postsHeader: _colors2.default.gray
	    },
	    sizes: {
	      closedHeight: 80,
	      postsListItemH1Font: 1.3,
	      postsListItemH2Font: 1.1,
	      fontIncraseForM: 1.15,
	      fontIncraseForL: 1.3
	    }
	  },
	  main: {
	    colors: {
	      background: _colors2.default.background,
	      title: _colors2.default.gray,
	      subTitle: _colors2.default.gray,
	      meta: _colors2.default.gray,
	      content: _colors2.default.dark,
	      footer: _colors2.default.gray,
	      contentHeading: _colors2.default.gray,
	      blockquoteFrame: _colors2.default.lightGray,
	      link: _colors2.default.accent,
	      linkHover: _colors2.default.dark,
	      fbCommentsColorscheme: 'light'
	    },
	    sizes: {
	      articleMaxWidth: '50em'
	    },
	    fonts: {
	      title: {
	        size: 1.9,
	        sizeM: 2.5,
	        sizeL: 2.7,
	        weight: 600,
	        lineHeight: 1.1
	      },
	      subTitle: {
	        size: 1.5,
	        sizeM: 1.8,
	        sizeL: 1.95,
	        weight: 300,
	        lineHeight: 1.1
	      },
	      meta: {
	        size: 0.9,
	        weight: 600
	      },
	      content: {
	        size: 1.0,
	        sizeM: 1.15,
	        sizeL: 1.1,
	        lineHeight: 1.6
	      },
	      contentHeading: {
	        h2Size: 1.5,
	        h3Size: 1.3,
	        weight: 600,
	        lineHeight: 1.3
	      },
	      footer: {
	        size: 1,
	        lineHeight: 1.4
	      }
	    }
	  },
	  footer: {
	    colors: {
	      text: (0, _color2.default)(_colors2.default.gray).lighten(0.5).string(),
	      link: _colors2.default.accent,
	      linkHover: (0, _color2.default)(_colors2.default.accent).lighten(0.2).string()
	    },
	    fonts: {
	      footnote: {
	        size: 0.8,
	        lineHeight: 1.4
	      }
	    }
	  },
	  bars: {
	    colors: {
	      background: _colors2.default.background,
	      icon: _colors2.default.gray,
	      text: _colors2.default.gray
	    },
	    sizes: {
	      actionsBar: 60,
	      infoBar: 60
	    }
	  },
	  mediaQueryTresholds: {
	    M: 600,
	    L: 1024
	  },
	  palette: {
	    primary: {
	      main: _colors2.default.accent
	    },
	    action: {
	      hover: 'rgba(0, 0, 0, 0.01)'
	    }
	  },
	  typography: {
	    fontFamily: 'Cereal-Book',
	    fontSize: 16
	  }
	});
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isWideScreen = isWideScreen;
	exports.timeoutThrottlerHandler = timeoutThrottlerHandler;
	
	var _theme = __webpack_require__(332);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWideScreen() {
	  if (typeof window !== 'undefined') {
	    var windowWidth = window.innerWidth;
	    var mediaQueryL = _theme2.default.mediaQueryTresholds.L;
	
	    return windowWidth >= mediaQueryL;
	  }
	}
	
	function timeoutThrottlerHandler(timeouts, name, delay, handler) {
	  if (!timeouts[name]) {
	    timeouts[name] = setTimeout(function () {
	      timeouts[name] = null;
	      handler();
	    }, delay);
	  }
	}

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(110);
	
	var _CssBaseline = __webpack_require__(496);
	
	var _CssBaseline2 = _interopRequireDefault(_CssBaseline);
	
	var _getPageContext = __webpack_require__(629);
	
	var _getPageContext2 = _interopRequireDefault(_getPageContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withRoot(Component) {
	  var WithRoot = function (_React$Component) {
	    _inherits(WithRoot, _React$Component);
	
	    function WithRoot(props) {
	      _classCallCheck(this, WithRoot);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.pageContext = null;
	
	
	      _this.pageContext = _this.props.pageContext || (0, _getPageContext2.default)();
	      return _this;
	    }
	
	    WithRoot.prototype.componentDidMount = function componentDidMount() {
	      // Remove the server-side injected CSS.
	      var jssStyles = document.querySelector('#server-side-jss');
	      if (jssStyles && jssStyles.parentNode) {
	        jssStyles.parentNode.removeChild(jssStyles);
	      }
	    };
	
	    WithRoot.prototype.render = function render() {
	      // MuiThemeProvider makes the theme available down the React tree thanks to React context.
	      return _react2.default.createElement(
	        _styles.MuiThemeProvider,
	        { theme: this.pageContext.theme, sheetsManager: this.pageContext.sheetsManager },
	        _react2.default.createElement(_CssBaseline2.default, null),
	        _react2.default.createElement(Component, this.props)
	      );
	    };
	
	    return WithRoot;
	  }(_react2.default.Component);
	
	  WithRoot.propTypes = {
	    pageContext: _propTypes2.default.object
	  };
	
	  return WithRoot;
	}
	
	exports.default = withRoot;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-4ed7b33b036d60b3e3a8.js